<!-- eslint-disable max-len -->
<template>
  <div
    :id="id[stackLevel - 1]"
    :class="{ 'properties-field-group': isGroup }"
    class="properties-field"
  >
    <div
      v-if="fieldDetail"
      class="wrap-properties"
    >
      <!-- Title Properties -->
      <div class="properties-field-title">
        <h4 class="title">
          Properties
          <div class="title-badge">Field</div>
        </h4>
        <div
          class="close-properties"
          @click="!showModalFieldLibrary ? submitForm(true) : null"
        >
          &times;
        </div>

        <div class="wrap-type">
          <img :src="require(`@/assets/new-form-ui/field-icon/${fieldDetail.type}.svg`)">
          <div class="text-type">{{ propertyTitle }}</div>
        </div>
      </div>

      <!-- Content Properties -->
      <div class="properties-field-content">
        <div class="section-field input-field">
          <b-row v-if="!isSearch">
            <!-- Key Properties -->
            <b-col cols="12">
              <b-form :class="{'error-input' : $v.dataSetup.key.$error}">
                <label> Key </label>
                <j-input
                  v-model="dataSetup.key"
                  placeholder="Field key"
                />
                <div class="field-information">
                  A distinct characteristic of an object specified
                </div>
              </b-form>
            </b-col>

            <!-- Mandatory Properties -->
            <b-col
              v-if="!isDataset && type !== 'data_preview' && (
                dataSetup.type.id !== 'separator' &&
                dataSetup.type.id !== 'custom_html' &&
                dataSetup.type.id !== 'text_label' &&
                dataSetup.type.id !== 'progress_bar' &&
                dataSetup.type.id !== 'group' &&
                dataSetup.type.id !== 'table_group'
              )"
              cols="4"
              class="d-flex flex-column my-2"
            >
              <label> Mandatory </label>
              <j-switch v-model="dataSetup.isMandatory" />
            </b-col>

            <!-- Disable Properties -->
            <b-col
              v-if="!isDataset && !isTableEditable && type !== 'data_preview' && (
                dataSetup.type.id !== 'separator' &&
                dataSetup.type.id !== 'custom_html' &&
                dataSetup.type.id !== 'text_label' &&
                dataSetup.type.id !== 'progress_bar' &&
                dataSetup.type.id !== 'group' &&
                dataSetup.type.id !== 'table_group'
              )"
              cols="4"
              class="d-flex flex-column my-2"
            >
              <label> Disable </label>
              <j-switch v-model="dataSetup.isDisable" />
            </b-col>

            <!-- Hidden Properties -->
            <b-col
              v-if="!isDataset && !isTableEditable && type !== 'data_preview' && (
                dataSetup.type.id !== 'separator' &&
                dataSetup.type.id !== 'custom_html' &&
                dataSetup.type.id !== 'text_label' &&
                dataSetup.type.id !== 'progress_bar'
              )"
              cols="4"
              class="d-flex flex-column my-2"
            >
              <label> Hidden </label>
              <j-switch v-model="dataSetup.isHidden" />
            </b-col>
          </b-row>

          <!-- Label Properties -->
          <b-form
            v-if="!isTableEditable"
            :class="{'error-input' : $v.dataSetup.name.$error}"
          >
            <label> Label </label>
            <j-input
              v-model="dataSetup.name"
              placeholder="Enter field label"
            />
            <div class="field-information">
              Field Labels are the name of the data entry area form that help let users know what information to enter into the field.
            </div>
          </b-form>

          <!-- Placeholder Properties -->
          <b-form
            v-if="isUsePlaceholder"
            :class="{'error-input' : $v.dataSetup.placeholder.$error}">
            <label> Placeholder </label>
            <j-input
              v-model="dataSetup.placeholder"
              placeholder="Enter field placeholder"
            />
            <div class="field-information">
              Placeholders are words that can refer to an instance of value
            </div>
          </b-form>

          <!-- Width Properties -->
          <b-form
            v-if="type === 'group' && parentType === 'table_group'"
            :class="{'error-input' : $v.dataSetup.width.$error}">
            <label> Width </label>
            <j-single-select
              v-model="dataSetup.width"
              :options="widthOptions"
              :placeholder="'Select Width'"
              label="name"
            />
          </b-form>

          <!-- Grid Properties -->
          <b-form
            v-if="isUseGrid"
            :class="{'error-input' : $v.dataSetup.grid.$error}">
            <label> Width </label>
            <div class="input-width">
              <input
                v-model="dataSetup.grid"
                type="range"
                min="1"
                max="12"
              >
              <div class="value">
                <span>{{ dataSetup.grid }}</span> / 12
              </div>
            </div>
            <div class="field-information">
              The width-size property defines the number of columns in your width layout, and it can define the width of each column.
            </div>
          </b-form>

          <!-- Format Text Label -->
          <b-form
            v-if="dataSetup.type.id === 'text_label'"
            :class="{'error-input' : $v.dataSetup.formatTextLabel.$error}">
            <label> Format </label>
            <j-single-select
              v-model="dataSetup.formatTextLabel"
              :custom="true"
              :options="formatOptions"
              placeholder="Select format"
            >
              <template
                slot-scope="node"
                slot="node-custom"
              >
                <img
                  :src="require(`@/assets/icon/column-type/${setIconType(node.node.id)}.svg`)"
                  style="width:14px;height:auto;margin-right:5px;"> {{ node.node.label }}
              </template>
            </j-single-select>
            <div class="field-information">
              The format is the format for showing label text
            </div>
          </b-form>

          <!-- Timezone field -->
          <b-form
            v-if="(dataSetup.type.id === 'date' ||
              dataSetup.type.id === 'time' ||
              dataSetup.type.id === 'date_time' ||
              dataSetup.type.id === 'timer' ||
              (dataSetup.type.id === 'text_label' && (dataSetup.formatTextLabel === 'datetime' ||
              dataSetup.formatTextLabel === 'time' ||
              dataSetup.formatTextLabel === 'dd-mmm-yyyy' ||
              dataSetup.formatTextLabel === 'mmmm dd, yyyy'))) && !isSearch && !isDataset
            "
          >
            <label> Timezone </label>
            <j-single-select
              v-model="dataSetup.timezone"
              :options="listTimezone"
              :placeholder="'Select Timezone'"
              label="text"
              value-format="object"
            />
          </b-form>

          <b-form
            v-if="!isSearch && !isDataset && !isTableEditable &&
              (dataSetup.type.id === 'currency' ||
              dataSetup.type.id === 'currency_selection' ||
            (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'currency'))"
            :class="{'error-input' : $v.dataSetup.defaultCurrency.$error}">
            <label> Default Currency </label>
            <j-single-select
              v-model="$v.dataSetup.defaultCurrency.$model"
              :options="list_currency"
              label="symbol_name"
              placeholder="Select Default Currency"
              @getData="changeCurrency" />

            <div class="field-information">
              The default currency is the value currency specified in the field value attribute
            </div>
          </b-form>

          <!-- Default Value Properties -->
          <b-form
            v-if="!isSearch && !isDataset && !isTableEditable && type === 'default' &&
              (dataSetup.type.id === 'text' ||
              dataSetup.type.id === 'descriptive' ||
              dataSetup.type.id === 'number'||
              dataSetup.type.id === 'number_decimal' ||
              dataSetup.type.id === 'date' ||
              dataSetup.type.id === 'time' ||
              dataSetup.type.id === 'date_time' ||
              dataSetup.type.id === 'currency' ||
              dataSetup.type.id === 'currency_selection' ||
              dataSetup.type.id === 'single_selection' ||
              dataSetup.type.id === 'slider' ||
            (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel))"
            :class="{'error-input' : $v.dataSetup.defaultValue.$error}">
            <label> Default Value </label>
            <j-input
              v-if="dataSetup.type.id === 'text' ||
                dataSetup.type.id === 'descriptive' ||
                dataSetup.type.id === 'single_selection' ||
                dataSetup.type.id === 'slider' ||
              (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'text')"
              v-model="dataSetup.defaultValue"
              placeholder="Enter Default Value"/>
            <j-input
              v-if="dataSetup.type.id === 'number' ||
                dataSetup.type.id === 'number_decimal' ||
              (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'number')"
              v-model="dataSetup.defaultValue"
              placeholder="Enter Default Value"
              type="number"/>
            <j-date-time
              v-if="dataSetup.type.id === 'date' ||
                (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'dd-mmm-yyyy') ||
              (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'mmmm dd, yyyy')"
              :data="dataSetup.defaultValue"
              placeholder="Enter Default Value"
              format="MMM dd, yyyy"
              class="m__b--25"
              @getTimestamp="setValueDateAndAtime($event, dataSetup.defaultValue)"/>
            <j-clockpicker
              v-if="dataSetup.type.id === 'time' ||
              (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'time')"
              :data="dataSetup.defaultValue"
              placeholder="Enter Default Value"
              @input="setValueDateAndAtime($event, dataSetup.defaultValue)"/>
            <j-date-time
              v-if="dataSetup.type.id === 'date_time' ||
              (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'datetime')"
              :type="'datetime'"
              :data="dataSetup.defaultValue"
              placeholder="Enter Default Value"
              format="MMM dd, yyyy, HH:mm"
              class="m__b--25"
              @getTimestamp="setValueDateAndAtime($event, dataSetup.defaultValue)"/>
            <j-currency
              v-if="(dataSetup.type.id === 'currency' ||
                dataSetup.type.id === 'currency_selection' ||
              (dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'currency')) && showDefaultCurrency"
              v-model="dataSetup.defaultValue"
              :options="setCurrencyOptions(dataSetup.isAllowMinusValue)"
              :input_mode="true"
              placeholder="Enter Default Value"/>

            <div class="field-information">
              The default value is the value specified in the field value attribute
            </div>
          </b-form>

          <b-form
            v-if="!isSearch && !isDataset && !isTableEditable && dataSetup.type.id === 'currency_selection'"
            :class="{'error-input' : $v.dataSetup.loadRate.$error}">
            <label> Function Load Rate </label>
            <j-single-select
              v-model="$v.dataSetup.loadRate.$model"
              :options="listFunction"
              :placeholder="'Select Function'"
              label="name" />

            <div class="field-information">
              The function load rate is the function for get rate currency
            </div>
          </b-form>

          <!-- View Options Properties -->
          <div
            v-if="dataSetup.type.id === 'dynamic_field'"
            class="configuration-section">
            <h4 class="configuration-section-title">View Options</h4>
            <p class="configuration-section-desc">
              Options for field implementation as settings view or render view
            </p>

            <div class="d-flex align-items-center">
              <div
                v-for="view in viewDynamicOptions"
                :key="view.id"
                :class="{ 'active': view.id === dataSetup.viewOptions,
                          'disabled': (!isDetailView && view.id === 'settings') || (isDetailView && !isPageScreen && view.id === 'settings') }"
                class="div-list-language"
                @click="changeViewDynamic(view.id)"
              >
                {{ view.name }}
              </div>
            </div>
          </div>

          <!-- Slider Options -->
          <div
            v-if="dataSetup.type.id === 'slider'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Slider Options</h4>
            <p class="configuration-section-desc">
              Options for field implementation as Slider Range (Number) or Selection (Text)
            </p>

            <div class="div-summary-list-type mt-2">
              <div
                :class="{'type--active': dataSetup.sliderOptions === 'range'}"
                class="type"
                @click="dataSetup.sliderOptions = 'range'"
              >
                RANGE
              </div>
              <div
                :class="{'type--active': dataSetup.sliderOptions === 'string'}"
                class="type"
                @click="dataSetup.sliderOptions = 'string'"
              >
                SELECTION
              </div>
            </div>
          </div>
        </div>

        <!-- Parse Variable Properties -->
        <div
          v-if="(dataSetup.type.id !== 'separator' && dataSetup.type.id !== 'custom_html') && !isTableEditable"
          class="section-field input-field"
        >
          <h4 class="title-section">Parse Value To</h4>

          <b-form :class="{'error-input' : $v.dataSetup.variable.$error}">
            <label> Column </label>
            <j-input
              v-if="parentType.includes('external_api')"
              v-model="dataSetup.variable"
              placeholder="Enter Column"
            />
            <j-single-select
              v-else
              v-model="dataSetup.variable"
              :options="variableOptionsFiltered"
              :placeholder="'Select Column'"
              value-format="object"
              label="label"/>
          </b-form>
        </div>

        <!-- Config Properties -->
        <div
          v-if="isHaveConfig"
          class="section-field input-field"
        >
          <h4 class="title-section">Configuration</h4>

          <!-- Maps Properties -->
          <div
            v-if="dataSetup.type.id === 'location'"
            class="configuration-section"
          >
            <b-form :class="{'error-input' : $v.dataSetup.isShowMaps.$error}">
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title">Show Maps</h4>
                  <p class="configuration-section-desc m-0">
                    Displays a map according to the specified location
                  </p>
                </div>
                <j-switch v-model="dataSetup.isShowMaps"/>
              </div>
            </b-form>
          </div>

          <!-- Location Type Properties -->
          <div
            v-if="dataSetup.type.id === 'location'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Location Type</h4>
            <p class="configuration-section-desc">
              The type of location that will be used as an option when the user opens the form
            </p>
            <b-form :class="{'error-input' : $v.dataSetup.locationType.$error}">
              <div class="div-input-location">
                <label>Current Location</label>
                <j-switch v-model="currentLocation" />
              </div>
              <div class="div-input-location">
                <label>Manual Location</label>
                <j-switch v-model="manualLocation" />
              </div>
            </b-form>
          </div>

          <!-- Option List Properties -->
          <div
            v-if="dataSetup.type.id === 'single_selection'||
              dataSetup.type.id === 'multiple_selection'||
              dataSetup.type.id === 'photo' ||
              dataSetup.type.id === 'attachment' ||
            (dataSetup.type.id === 'slider' && dataSetup.sliderOptions === 'string')"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">
              {{ dataSetup.type.id === 'attachment' ? 'Attachment Items' : 'Options List' }}
            </h4>
            <p class="configuration-section-desc">
              {{ dataSetup.type.id === 'attachment' ?
                'Attachment list, user can attach one or all attachments.' :
                'Option list is displays a list of values, user can be select one from the list.'
              }}
            </p>
            <div
              v-for="(itemOptions, index) in dataSetup.options"
              :key="index">
              <div
                :class="{'error-input' : $v.dataSetup.options.$each[index].$error}"
                class="div-input-option"
              >
                <input
                  v-model="dataSetup.options[index]"
                  :placeholder="dataSetup.type.id === 'attachment' ? 'Item' : 'Option'"
                  type="text"
                >
                <i
                  class="fa fa-trash cursor-pointer"
                  @click="deleteOptions(index)"
                />
              </div>
            </div>
            <div
              class="btn-add-config"
              @click="addoptions">
              + Add {{ dataSetup.type.id === 'attachment' ? 'item' : 'options' }}
            </div>
          </div>

          <!-- Option Range Properties -->
          <div
            v-if="dataSetup.type.id === 'slider' && dataSetup.sliderOptions === 'range'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">
              Range Option
            </h4>
            <p class="configuration-section-desc">
              Options are displayed as a range from minimum to maximum value
            </p>
            <b-row>
              <b-col md="6">
                <b-form>
                  <label>Minimum</label>
                  <j-input
                    v-model="dataSetup.sliderMinimum"
                    type="number"
                    placeholder="Enter minimum value"
                  />
                </b-form>
              </b-col>
              <b-col md="6">
                <b-form>
                  <label>Maximum</label>
                  <j-input
                    v-model="dataSetup.sliderMaximum"
                    type="number"
                    placeholder="Enter maximum value"
                  />
                </b-form>
              </b-col>
            </b-row>
          </div>

          <!-- Option List Properties radio or checkbox -->
          <div
            v-if="dataSetup.type.id === 'radio' || dataSetup.type.id === 'checkbox'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Options List</h4>
            <p class="configuration-section-desc">
              Option list is displays a list of values, user can be select one from the list.
            </p>
            <div
              v-for="(itemOptions, index) in dataSetup.optionsObject"
              :key="index">
              <div
                :class="{'error-input' :
                  $v.dataSetup.optionsObject.$each[index].label.$error ||
                  $v.dataSetup.optionsObject.$each[index].value.$error
                }"
                class="div-input-option">
                <input
                  v-model="dataSetup.optionsObject[index].label"
                  type="text"
                  placeholder="Label"
                  style="width: 40%"
                >
                <input
                  v-model="dataSetup.optionsObject[index].value"
                  type="text"
                  placeholder="Value"
                  style="width: 40%"
                >
                <i
                  class="fa fa-trash cursor-pointer"
                  @click="deleteOptionsObject(index)"
                />
              </div>
            </div>
            <div
              class="btn-add-config"
              @click="addoptionsObject">
              + Add options
            </div>
          </div>

          <!-- Accepted File Type Properties -->
          <div
            v-if="dataSetup.type.id === 'attachment' || dataSetup.type.id === 'multiple_attachment_dynamic' || dataSetup.type.id === 'single_attachment'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Accepted File Type</h4>
            <p class="configuration-section-desc">
              File types allowed to upload
            </p>
            <b-form :class="{'error-input' : $v.dataSetup.acceptedFileType.$error}">
              <label>File Type</label>
              <j-multi-select
                v-model="$v.dataSetup.acceptedFileType.$model"
                :options="list_accepted_file_type"
                placeholder="Select File Type"/>
            </b-form>
          </div>

          <!-- Use Camera Properties -->
          <div
            v-if="dataSetup.type.id === 'attachment' || dataSetup.type.id === 'multiple_attachment_dynamic' || dataSetup.type.id === 'single_attachment'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Attachment Source</h4>
            <p class="configuration-section-desc">
              Choose the method to be the source of the attachment
            </p>

            <b-form :class="{'error-input' : $v.dataSetup.isUseCamera.$error}">
              <div class="div-input-location">
                <label>File Manager</label>
                <j-switch v-model="dataSetup.sourceCamera" />
              </div>
              <div class="div-input-location">
                <label>Rear Camera</label>
                <j-switch v-model="rearCamera" />
              </div>
              <div class="div-input-location">
                <label>Front Camera</label>
                <j-switch v-model="frontCamera" />
              </div>
            </b-form>
          </div>

          <!-- View Style Options -->
          <div
            v-if="dataSetup.type.id === 'attachment' || dataSetup.type.id === 'multiple_attachment_dynamic' || dataSetup.type.id === 'single_attachment'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">View Style Options</h4>
            <p class="configuration-section-desc">
              Options for style field for attachment
            </p>
            <div class="div-summary-list-type mt-2">
              <div
                :class="{'type--active': dataSetup.viewStyleAttachment === 'list'}"
                class="type"
                @click="dataSetup.viewStyleAttachment = 'list'"
              >
                <img
                  :src="require(`@/assets/icon/style-attachment-list${dataSetup.viewStyleAttachment === 'list' ? '-active' : ''}.svg`)"
                  height="10">
                List
              </div>
              <div
                :class="{'type--active': dataSetup.viewStyleAttachment === 'grid'}"
                class="type"
                @click="dataSetup.viewStyleAttachment = 'grid'"
              >
                <img
                  :src="require(`@/assets/icon/style-attachment-grid${dataSetup.viewStyleAttachment === 'grid' ? '-active' : ''}.svg`)"
                  height="10">
                Grid
              </div>
            </div>
          </div>

          <!-- Use Watermark Properties -->
          <!-- <div
            v-if="type !== 'data_preview' && (dataSetup.type.id === 'attachment' || dataSetup.type.id === 'multiple_attachment_dynamic' || dataSetup.type.id === 'single_attachment')"
            class="configuration-section"
          >
            <b-form :class="{'error-input' : $v.dataSetup.isUseWatermark.$error}">
              <div class="configuration-toggle-in-title mb-3">
                <div class="wrap-title">
                  <h4 class="configuration-section-title m-0">Use Watermark</h4>
                </div>
                <j-switch v-model="dataSetup.isUseWatermark" />
              </div>

              <b-form
                v-if="dataSetup.isUseWatermark"
                :class="{'error-input' : $v.dataSetup.field1.$error}">
                <label> Field 1 </label>
                <j-single-select
                  v-model="dataSetup.field1"
                  :options="variableOptionsWatermark"
                  :placeholder="'Select Field'"
                  label="label"/>
              </b-form>
              <b-form
                v-if="dataSetup.isUseWatermark"
                :class="{'error-input' : $v.dataSetup.field2.$error}">
                <label> Field 2 </label>
                <j-single-select
                  v-model="dataSetup.field2"
                  :options="variableOptionsWatermark"
                  :placeholder="'Select Field'"
                  label="label"/>
              </b-form>
              <b-form
                v-if="dataSetup.isUseWatermark"
                :class="{'error-input' : $v.dataSetup.field3.$error}">
                <label> Field 3 </label>
                <j-single-select
                  v-model="dataSetup.field3"
                  :options="variableOptionsWatermark"
                  :placeholder="'Select Field'"
                  label="label"/>
              </b-form>
            </b-form>
          </div> -->

          <!-- Field Reference Dynamic Field Properties -->
          <div
            v-if="dataSetup.type.id === 'dynamic_field' && dataSetup.viewOptions === 'render'"
            :class="{'error-input' : dataSetup.type.id === 'dynamic_field' && dataSetup.viewOptions === 'render' && $v.dataSetup.sourceData.fieldReference.$error }"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Field Reference</h4>
            <p class="configuration-section-desc">
              The field will be related to the reference field
            </p>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.fieldReference.$error}">
              <label> Field </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.fieldReference.$model"
                :options="list_field_reference"
                label="label"
                placeholder="Select field"/>
            </b-form>
          </div>

          <!-- Data Source Properties -->
          <div
            v-if="dataSetup.type.id === 'relation_record' ||
              dataSetup.type.id === 'multiple_relation_record' ||
            (dataSetup.type.id === 'dynamic_field' && dataSetup.viewOptions === 'render')"
            :class="{'error-input' : $v.dataSetup.sourceData.tableGroup.$error }"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Data Source</h4>
            <p class="configuration-section-desc">
              Choose the data table that will be used as the data source
            </p>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.tableGroup.$error}">
              <label> Table Group </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.tableGroup.$model"
                :error-required="$v.dataSetup.sourceData.tableGroup.$error"
                :options="tableGroupOptions"
                :placeholder="'Select Table Group'"
                value-format="object"
                label="name"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.form.$error}">
              <label> Table </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.form.$model"
                :error-required="$v.dataSetup.sourceData.form.$error"
                :disabled="!dataSetup.sourceData.tableGroup"
                :options="tableOptions"
                :placeholder="'Select Table'"
                value-format="object"
                label="name"/>
            </b-form>
          </div>

          <!-- Data Source Ext Api Properties -->
          <div
            v-if="dataSetup.type.id === 'relation_record_external_api' || dataSetup.type.id === 'multiple_relation_record_external_api'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Data Source</h4>
            <p class="configuration-section-desc">
              Fetching data sources using API mechanism
            </p>
            <div class="div-external-api">
              <div class="icon-ext-api">
                <img src="@/assets/new-form-ui/ext-api.svg">
              </div>

              <div class="ext-api-desc">
                <div class="ext-api-url">
                  <span
                    v-if="dataSetup.sourceExternal"
                    class="method"
                  >
                    {{ dataSetup.sourceExternal.method }}
                  </span>
                  {{ dataSetup.sourceExternal ? dataSetup.sourceExternal.url : 'API Not Configure' }}
                </div>
                <div
                  class="edit-btn"
                  @click="openModalExternalUrl()"
                >
                  Edit
                </div>
              </div>
            </div>
          </div>

          <!-- Filter Properties -->
          <div
            v-if="
              type !== 'data_preview' &&
                (dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'multiple_relation_record' || (dataSetup.type.id === 'dynamic_field' && dataSetup.viewOptions === 'render'))
            "
            :class="{'error-input' : dataSetup.type.id === 'dynamic_field' && dataSetup.viewOptions === 'render' && $v.dataSetup.filter.$error }"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Filter</h4>
                <p class="configuration-section-desc">
                  Filter data according to the parameters
                </p>
              </div>

              <!-- Filter Operator -->
              <div class="filter-option">
                <div class="filter-selected">{{ dataSetup.filterOperator }}</div>
                <i
                  class="fa fa-chevron-down"
                  @click="showFilterOptions = true"
                />

                <!-- Select Filter Operator -->
                <div
                  v-if="showFilterOptions"
                  class="filter-options"
                >
                  <p>Operator</p>

                  <div class="d-flex align-items-center justify-content-around">
                    <div
                      v-for="operator in filterOperatorOptions"
                      :key="operator.id"
                      :class="{'operator-selected': operator.id === dataSetup.filterOperator }"
                      class="operator-option"
                      @click="closeFilterOptions(operator.id)"
                    >
                      {{ operator.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-for="(data, index) in dataSetup.filter"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteFilter(index)"
                />
              </div>
              <b-form
                :class="{'error-input' : $v.dataSetup.filter.$each[index].key.$error }"
                class="mb-2">
                <label> Column </label>
                <j-single-select
                  v-model="data.key"
                  :error-required="$v.dataSetup.filter.$each[index].key.$error"
                  :options="list_field_class"
                  :placeholder="'Select Column'"
                  value-format="object"
                  label="label"/>
              </b-form>
              <b-form :class="{'error-input' : $v.dataSetup.filter.$each[index].value.$error }">
                <label> Value </label>
                <j-input
                  v-model="data.value"
                  :error-required="$v.dataSetup.filter.$each[index].value.$error"
                  :placeholder="'Input Filter Value'"/>
              </b-form>
            </div>

            <div
              class="btn-add-config"
              @click="addFilter">
              + Add Parameter
            </div>

            <div
              v-if="dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'multiple_relation_record'"
              class="separator" />

            <!-- Retrieve Data Properties -->
            <div
              v-if="(dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'multiple_relation_record') && !isTableEditable"
              class="configuration-section"
            >
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title m-0">Retrieve data from Value Field</h4>
                </div>
                <j-switch v-model="dataSetup.isWithParam" />
              </div>

              <div v-if="dataSetup.isWithParam">
                <b-form
                  :class="{'error-input' : $v.dataSetup.filterColumn.$error}"
                  class="mb-2"
                >
                  <label> Column </label>
                  <j-single-select
                    v-model="$v.dataSetup.filterColumn.$model"
                    :error-required="$v.dataSetup.filterColumn.$error"
                    :options="list_field_class"
                    label="label"
                    placeholder="Select Column"/>
                </b-form>
                <b-form
                  :class="{'error-input' : $v.dataSetup.fieldKey.$error}"
                  class="mb-2"
                >
                  <label> Value </label>
                  <j-single-select
                    v-model="$v.dataSetup.fieldKey.$model"
                    :error-required="$v.dataSetup.fieldKey.$error"
                    :options="list_field_key"
                    label="id"
                    placeholder="Input Filter Value"/>
                </b-form>
              </div>
            </div>
          </div>

          <!-- Sorting Properties -->
          <div
            v-if="type !== 'data_preview' && (dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'multiple_relation_record')"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Sorting</h4>
            <p class="configuration-section-desc">
              The displayed data can be sorted according to the specified parameters
            </p>
            <b-form
              :class="{'error-input' : $v.dataSetup.sorting.key.$error}"
              class="mb-2"
            >
              <label> Column </label>
              <j-single-select
                v-model="dataSetup.sorting.key"
                :error-required="false"
                :options="list_field_class"
                :placeholder="'Select column'"
                value-format="object"
                label="label"/>
            </b-form>

            <b-form
              :class="{'error-input' : $v.dataSetup.sorting.order.$error}"
              class="mb-3"
            >
              <label> Order Type </label>
              <j-single-select
                v-model="dataSetup.sorting.order"
                :error-required="false"
                :options="orderOptions"
                :placeholder="'Select order type'"
                value-format="object"
                label="label"/>
            </b-form>
          </div>

          <!-- Data Selection Properties -->
          <div
            v-if="dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'multiple_relation_record'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Data Selection</h4>
            <p class="configuration-section-desc">
              Data selection is defined as the process of determining the appropriate data type and source on this field
            </p>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.setValue.$error}">
              <label> Value Selected </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.setValue.$model"
                :options="list_field"
                label="name"
                placeholder="Select column"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.showData.$error}">
              <label> Show Data Option </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.showData.$model"
                :options="list_field"
                label="name"
                placeholder="Select column"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.searchData.$error}">
              <label> Search Data Option </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.searchData.$model"
                :options="list_field"
                label="name"
                placeholder="Select column"/>
            </b-form>
            <b-form
              v-if="type !== 'data_preview'"
              :class="{'error-input' : $v.dataSetup.isAutoShow.$error}"
              class="d-flex flex-column"
            >
              <label> Auto Show All Data </label>
              <j-switch v-model="dataSetup.isAutoShow" />
            </b-form>
          </div>

          <!-- Data Selection Ext Api Properties -->
          <div
            v-if="dataSetup.type.id === 'relation_record_external_api' || dataSetup.type.id === 'multiple_relation_record_external_api'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Data Selection</h4>
            <p class="configuration-section-desc">
              Data selection is defined as the process of determining the appropriate data type and source on this field
            </p>
            <b-form :class="{'error-input' : $v.dataSetup.sourceExternalVariable.$error}">
              <label> Show Data Option </label>
              <j-input
                v-model="dataSetup.sourceExternalVariable"
                placeholder="Enter variable"/>
            </b-form>
            <b-form :class="{'error-input' : $v.dataSetup.sourceExternalSetValue.$error}">
              <label> Value Selected </label>
              <j-single-select
                v-model="$v.dataSetup.sourceExternalSetValue.$model"
                :options="list_field_external"
                placeholder="Select column"/>
            </b-form>
            <b-form
              v-if="type !== 'data_preview'"
              :class="{'error-input' : $v.dataSetup.isAutoShow.$error}"
              class="d-flex flex-column"
            >
              <label> Auto Show All Data </label>
              <j-switch v-model="dataSetup.isAutoShow" />
            </b-form>
          </div>

          <!-- Data Selection Dynamic Field Properties -->
          <div
            v-if="dataSetup.type.id === 'dynamic_field' && dataSetup.viewOptions === 'render'"
            :class="{'error-input' : dataSetup.type.id === 'dynamic_field' && dataSetup.viewOptions === 'render' && $v.dataSetup.sourceData.dataSelection.$error }"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Data Selection</h4>
            <p class="configuration-section-desc">
              Data selection is defined as the process of determining the appropriate data type and source on this field
            </p>
            <b-form :class="{'error-input' : $v.dataSetup.sourceData.dataSelection.$error}">
              <label> Column </label>
              <j-single-select
                v-model="$v.dataSetup.sourceData.dataSelection.$model"
                :options="list_field_data_selection"
                label="name"
                placeholder="Select column"/>
            </b-form>
          </div>

          <!-- Data Preview Properties -->
          <div
            v-if="dataSetup.type.id === 'relation_record' && !isTableEditable && !isBulk && !isSearch && type !== 'data_preview'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Data Preview</h4>
                <p class="configuration-section-desc">
                  Displays the selected data with a customizable form display
                </p>
              </div>
              <j-switch v-model="dataSetup.isAutoFill" />
            </div>

            <draggable
              v-if="dataSetup.isAutoFill"
              v-model="dataSetup.fieldGroup"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.fieldGroup"
                :key="index"
                :class="{'selected': index === selectedIndexField}"
                class="field-list"
                @click="editField(index, 'data_preview')"
              >
                <p class="column-name">{{ data.name }}</p>

                <field-preview
                  :column="data"
                />

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click.stop="editField(index, 'data_preview')"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click.stop="deleteField(index)"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              v-if="dataSetup.isAutoFill"
              class="btn-add-config"
              @click="openModalFieldLibrary('data_preview')"
            >
              + Add Field
            </div>
          </div>

          <!-- Data Direct Open Detail -->
          <div
            v-if="(dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'relation_record_external_api') &&
            !isTableEditable && !isBulk && !isSearch && type !== 'data_preview'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Direct Open Detail</h4>
                <p class="configuration-section-desc">
                  Allow users to open detailed info of selected data in a new tab
                </p>
              </div>
              <j-switch v-model="dataSetup.isDirectOpenDetail" />
            </div>
            <b-form
              v-if="dataSetup.isDirectOpenDetail"
              :class="{'error-input' : $v.dataSetup.formUiDirectOpenDetail.$error}"
            >
              <label> Experience Manager</label>
              <j-single-select
                v-model="dataSetup.formUiDirectOpenDetail"
                :load-options="loadOptionsFormUI"
                :is-async="true"
                :cache-option="false"
                :placeholder="'Experience Manager'"
                value-format="object"
                label="name"
              />
            </b-form>
          </div>

          <!-- Data Preview Ext Api Properties -->
          <div
            v-if="dataSetup.type.id === 'relation_record_external_api' && !isTableEditable && !isBulk && !isSearch && type !== 'data_preview'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Data Preview</h4>
                <p class="configuration-section-desc">
                  Displays the selected data with a customizable form display
                </p>
              </div>
              <j-switch v-model="dataSetup.isAutoFill" />
            </div>

            <draggable
              v-if="dataSetup.isAutoFill"
              v-model="dataSetup.fieldGroup"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.fieldGroup"
                :key="index"
                :class="{'selected': index === selectedIndexField}"
                class="field-list"
                @click="editField(index, 'data_preview')"
              >
                <p class="column-name">{{ data.name }}</p>

                <field-preview
                  :column="data"
                />

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click.stop="editField(index, 'data_preview')"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click.stop="deleteField(index)"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              v-if="dataSetup.isAutoFill"
              class="btn-add-config"
              @click="openModalFieldLibrary('data_preview')"
            >
              + Add Field
            </div>
          </div>

          <!-- Date & Date time Properties -->
          <div
            v-if="(dataSetup.type.id === 'date' || dataSetup.type.id === 'date_time') && !isBulk && !isSearch && type !== 'data_preview'"
            class="configuration-section"
          >
            <b-form :class="{'error-input' : $v.dataSetup.isDisableBackDate.$error}">
              <div class="configuration-toggle-in-title">
                <div class="wrap-title">
                  <h4 class="configuration-section-title">Disable Back Date</h4>
                  <p class="configuration-section-desc m-0">
                    Disabling the date picker before today
                  </p>
                </div>
                <j-switch v-model="dataSetup.isDisableBackDate" />
              </div>
            </b-form>
          </div>

          <!-- Initial Value -->
          <div
            v-if="isShowInitialValue"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Set Initial Value</h4>

            <div class="div-summary-list-type mt-2">
              <div
                :class="{'type--active': dataSetup.initialValue.type === 'static_value'}"
                class="type"
                @click="setInitialValueType('static_value')"
              >
                Static
              </div>
              <div
                :class="{'type--active': dataSetup.initialValue.type === 'function'}"
                class="type"
                @click="setInitialValueType('function')"
              >
                Function
              </div>
            </div>

            <b-form
              v-if="dataSetup.initialValue.type === 'static_value'"
              :class="{'error-input': $v.dataSetup.initialValue.value.$error}"
            >
              <label>Value</label>
              <j-input
                v-model="dataSetup.initialValue.value"
                :error-required="false"
                placeholder="Enter value"/>
            </b-form>

            <template v-if="dataSetup.initialValue.type === 'function'">
              <b-form
                :class="{'error-input': $v.dataSetup.initialValue.function_name.$error}"
              >
                <label>Function</label>
                <j-single-select
                  v-model="dataSetup.initialValue.function_name"
                  :error-required="false"
                  :options="listFunction"
                  placeholder="Select function"
                  label="name"/>
              </b-form>
              <b-form>
                <label>Params</label>
                <div
                  v-for="(data, index) in dataSetup.initialValue.params"
                  :key="index"
                  class="form-list">
                  <input
                    v-model="data.variable"
                    type="text"
                    placeholder="Variable"
                    class="name" >
                  <input
                    v-model="data.value"
                    type="text"
                    placeholder="Value"
                    class="value" >
                  <i
                    class="fa fa-trash"
                    @click="deleteParamInitialValue(index)" />
                </div>
                <div
                  class="btn-add-config"
                  @click="addParamInitialValue"
                >
                  + Add Params
                </div>
              </b-form>
            </template>
          </div>

          <!-- On Change Value Properties -->
          <div
            v-if="
              (dataSetup.type.id === 'number' ||
                dataSetup.type.id === 'number_decimal' ||
                dataSetup.type.id === 'currency' ||
                dataSetup.type.id === 'single_selection' ||
                dataSetup.type.id === 'text' ||
                dataSetup.type.id === 'date' ||
                dataSetup.type.id === 'time' ||
                dataSetup.type.id === 'date_time' ||
                dataSetup.type.id === 'radio' ||
                dataSetup.type.id === 'checkbox' ||
                dataSetup.type.id === 'toggle' ||
                dataSetup.type.id === 'password' ||
                dataSetup.type.id === 'single_attachment' ||
                dataSetup.type.id === 'relation_record' ||
                dataSetup.type.id === 'relation_record_external_api' ||
                dataSetup.type.id === 'descriptive' ||
                dataSetup.type.id === 'currency_selection' ||
                dataSetup.type.id === 'slider')
            && !isTableEditable && !isBulk && !isSearch && !isDataset && type !== 'data_preview' "
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">On Change Value</h4>
                <p class="configuration-section-desc">
                  The change event occurs when the value of an element has been changed
                </p>
              </div>
              <j-switch v-model="dataSetup.isValueChange" />
            </div>

            <b-form
              v-if="useEditorCode"
              :class="{'error-input' : $v.dataSetup.onValueChange.$error}"
            >
              <label class="mb-0"> Script </label>
              <img
                src="@/assets/icon/fullscreen.svg"
                alt="fullscreen"
                class="pull-right cursor-pointer"
                @click="fullscreenScript"
              >
              <j-monaco-editor
                v-if="openEditor"
                ref="scriptEditor"
                :value="dataSetup.onValueChange"
              />
            </b-form>
          </div>

          <!-- Group & Table Group Properties -->
          <div
            v-if="type !== 'data_preview' &&
            (dataSetup.type.id === 'group' || dataSetup.type.id === 'table_group') && variableOptionsGroup.length > 0"
            :class="{'error-input' : $v.dataSetup.fieldGroup.$error}"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Fields</h4>
            <p class="configuration-section-desc">
              The field used can be adjusted as needed
            </p>

            <draggable
              v-model="dataSetup.fieldGroup"
              :options="{
                animation:300,
                handle:'.icon-drag'
              }"
              class="d-flex flex-wrap"
            >
              <div
                v-for="(data, index) in dataSetup.fieldGroup"
                :key="index"
                :class="{'selected': index === selectedIndexField}"
                class="field-list"
                @click="editField(index, 'group')"
              >
                <p class="column-name">{{ data.name }}</p>

                <field-preview
                  :column="data"
                />

                <!-- Edit or Delete -->
                <div class="edit-or-delete">
                  <div class="button">
                    <!-- Edit -->
                    <div
                      class="edit"
                      @click.stop="editField(index, 'group')"
                    >
                      <i class="fa fa-pencil-square-o" />
                    </div>
                    <!-- Delete -->
                    <div
                      class="delete"
                      @click.stop="deleteField(index)"
                    >
                      <i class="fa fa-trash" />
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div
              class="btn-add-config"
              @click="openModalFieldLibrary('group')"
            >
              + Add Field
            </div>
          </div>

          <!-- Disable Button Properties -->
          <div
            v-if="type !== 'data_preview' && (dataSetup.type.id === 'group' || dataSetup.type.id === 'table_group') && variableOptionsGroup.length > 0"
            class="configuration-section"
          >
            <h4 class="configuration-section-title mb-2">Disable Buttons</h4>

            <div class="div-input-location">
              <label>Add More</label>
              <j-switch v-model="dataSetup.isDisableAddMore" />
            </div>
            <div class="div-input-location">
              <label>Delete Row</label>
              <j-switch v-model="dataSetup.isDisableDeleteRow" />
            </div>
          </div>

          <!-- Options Tags Properties -->
          <div
            v-if="dataSetup.type.id === 'single_tags_selection' || dataSetup.type.id === 'multiple_tags_selection'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title mb-2">Options</h4>

            <div
              v-for="(item, index) in dataSetup.tags"
              :key="index"
              class="div-filter"
            >
              <div class="header-filter">
                <div class="index">{{ index + 1 }}</div>
                <i
                  class="fa fa-trash"
                  @click="deleteTags(index)"
                />
              </div>
              <b-form class="mb-2">
                <label> Name </label>
                <j-input
                  v-model="item.name"
                  placeholder="Enter Name Value"/>
              </b-form>
              <b-row>
                <b-col md="6">
                  <j-color-picker
                    v-model="item.background"
                    :color="item.background"
                    label="Background"
                    picker="chrome" />
                </b-col>
                <b-col md="6">
                  <j-color-picker
                    v-model="item.font_color"
                    :color="item.font_color"
                    label="Font Color"
                    picker="chrome" />
                </b-col>
              </b-row>
            </div>

            <div
              class="btn-add-config"
              @click="addTags">
              + Add Options
            </div>
          </div>

          <!-- Custom HTML Properties -->
          <div
            v-if="(type !== 'group' || type !== 'data_preview') && dataSetup.type.id === 'custom_html'"
            class="configuration-section"
          >
            <quill-editor
              ref="myQuillEditor"
              v-model="dataSetup.html"
              :options="editorOption"
            />
          </div>

          <!-- Languange Properties -->
          <div
            v-if="type !== 'data_preview' && dataSetup.type.id === 'code_editor'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Language</h4>
            <p class="configuration-section-desc">
              The programming language used as the default language in the code editor
            </p>

            <div class="d-flex align-items-center">
              <div
                v-for="language in languageOptions"
                :key="language.id"
                :class="{ 'active': language.id === dataSetup.language }"
                class="div-list-language"
                @click="dataSetup.language = language.id"
              >
                {{ language.name }}
              </div>
            </div>
          </div>

          <!-- Allow Select Data Properties -->
          <div
            v-if="type !== 'data_preview' && (dataSetup.type.id === 'multiple_relation_record' || dataSetup.type.id === 'multiple_relation_record_external_api')"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Allow Select All Data</h4>
                <p class="configuration-section-desc">
                  One action to select or unselect all data options
                </p>
              </div>
              <j-switch v-model="dataSetup.isAllowSelectAllData" />
            </div>
          </div>

          <!-- Parse value to another column Properties -->
          <div
            v-if="dataSetup.type.id === 'currency_selection'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Parse value to another column</h4>
                <p class="configuration-section-desc">
                  Automatically separates values into other columns
                </p>
              </div>
              <j-switch v-model="dataSetup.isAdditionalDataKey" />
            </div>

            <b-form
              v-show="dataSetup.isAdditionalDataKey"
              :class="{'error-input': $v.dataSetup
              .additionalOriginAmount.$error}">
              <label> Column (Origin Amount) </label>
              <j-single-select
                v-model="dataSetup.additionalOriginAmount"
                :options="variableOptions.filter(f => f.type === 'number')"
                :error-required="false"
                :placeholder="'Select Column'"
                value-format="object"
                label="label"/>
            </b-form>
            <b-form
              v-show="dataSetup.isAdditionalDataKey"
              :class="{'error-input': $v.dataSetup
              .additionalOriginCurrency.$error}">
              <label> Column (Origin Currency) </label>
              <j-single-select
                v-model="dataSetup.additionalOriginCurrency"
                :options="variableOptions.filter(f => f.type === 'text')"
                :error-required="false"
                :placeholder="'Select Column'"
                value-format="object"
                label="label"/>
            </b-form>
            <b-form
              v-show="dataSetup.isAdditionalDataKey"
              :class="{'error-input': $v.dataSetup.additionalConvertionAmount.$error}">
              <label> Column (Convertion Amount) </label>
              <j-single-select
                v-model="dataSetup.additionalConvertionAmount"
                :options="variableOptions.filter(f => f.type === 'number')"
                :error-required="false"
                :placeholder="'Select Column'"
                value-format="object"
                label="label"/>
            </b-form>
            <b-form
              v-show="dataSetup.isAdditionalDataKey"
              :class="{'error-input': $v.dataSetup.additionalTargetCurrency.$error}">
              <label> Column (Target Currency) </label>
              <j-single-select
                v-model="dataSetup.additionalTargetCurrency"
                :options="variableOptions.filter(f => f.type === 'text')"
                :error-required="false"
                :placeholder="'Select Column'"
                value-format="object"
                label="label"/>
            </b-form>
            <b-form
              v-show="dataSetup.isAdditionalDataKey"
              :class="{'error-input': $v.dataSetup.additionalRate.$error}">
              <label> Column (Rate) </label>
              <j-single-select
                v-model="dataSetup.additionalRate"
                :options="variableOptions.filter(f => f.type === 'number')"
                :error-required="false"
                :placeholder="'Select Column'"
                value-format="object"
                label="label"/>
            </b-form>
          </div>

          <!-- Editable Rate Properties -->
          <div
            v-if="dataSetup.type.id === 'currency_selection'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Editable Rate</h4>
                <p class="configuration-section-desc">
                  The rate currency editable by user
                </p>
              </div>
              <j-switch v-model="dataSetup.isEditableRate" />
            </div>
          </div>

          <!-- Allow Minus Value Properties -->
          <div
            v-if="dataSetup.type.id === 'currency' || dataSetup.type.id === 'currency_selection'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Allow Minus Value</h4>
                <p class="configuration-section-desc">
                  Show currency in brackets as minus value sign
                </p>
              </div>
              <j-switch v-model="dataSetup.isAllowMinusValue" />
            </div>
          </div>

          <!-- Allow approver to edit -->
          <div
            v-if="isDetailView &&
              isApproverCanUpdate &&
              type !== 'data_preview' &&
              dataSetup.type.id !== 'separator' &&
            dataSetup.type.id !== 'custom_html'"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Allow approver to edit</h4>
                <p class="configuration-section-desc">
                  Approver can edit and update value of this field before continue to approve
                </p>
              </div>
              <j-switch v-model="dataSetup.isAllowApproverUpdate" />
            </div>
          </div>

          <!-- Text Label Options -->
          <div
            v-if="dataSetup.type.id === 'text_label'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Style</h4>
            <p class="configuration-section-desc">
              Custom design and appearance for text labels
            </p>

            <div
              v-for="(item, index) in style_text_label"
              :key="index"
            >
              <label>{{ item.label }}</label>
              <div class="div-summary-list-type">
                <div
                  v-for="opt in item.options"
                  :key="opt"
                  :class="{'type--active': checkActiveStyleTextLabel(item.label, opt)}"
                  class="type"
                  @click="setStyleTextLabel(item.label, opt)"
                >
                  <img
                    :src="require(`@/assets/new-form-ui/text-label/${opt}${checkActiveStyleTextLabel(item.label, opt) ? '-active' : ''}.svg`)"
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- Text Label Link -->
          <div
            v-if="dataSetup.type.id === 'text_label' && dataSetup.formatTextLabel === 'text'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Hyperlink</h4>
            <p class="configuration-section-desc">
              When the label is clicked it will be directed to the following link
            </p>

            <j-input
              v-model="dataSetup.linkTextLabel"
              placeholder="Enter url static or from hit function"/>
          </div>

          <!-- Progress Bar Color -->
          <div
            v-if="dataSetup.type.id === 'progress_bar'"
            class="configuration-section"
          >
            <h4 class="configuration-section-title">Color</h4>
            <p class="configuration-section-desc">
              Custom appearance for progress bar
            </p>

            <j-color-picker
              v-model="dataSetup.progressBarColor"
              :color="dataSetup.progressBarColor"
              label="Color"
              picker="chrome"
            />
          </div>

          <!-- Private file Properties -->
          <div
            v-if="useConfigPrivateStorage"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title">Private file</h4>
                <p class="configuration-section-desc">
                  Store the uploaded file to private storage
                </p>
              </div>
              <j-switch v-model="dataSetup.isPrivateFile" />
            </div>

            <div
              v-if="dataSetup.isPrivateFile"
              class="company-drive-path">
              <b-form-group>
                <label> Company Drive Path </label>
                <j-input
                  v-model="dataSetup.companyDrivePath"
                  placeholder="Input Path"
                />
              </b-form-group>
              <i
                class="fa fa-search icon-search"
                @click="$emit('open-modal-company-drive')"
              />
            </div>
          </div>

          <!-- Copy value Properties -->
          <div
            v-if="useConfigEnableCopyValue"
            class="configuration-section"
          >
            <div class="configuration-toggle-in-title">
              <div class="wrap-title">
                <h4 class="configuration-section-title m-0">Enable Copy Value</h4>
                <p class="configuration-section-desc">
                  Quickly copy specific data or field values with a single click
                </p>
              </div>
              <j-switch v-model="dataSetup.enableCopyValue" />
            </div>
          </div>
        </div>
      </div>

      <!-- Button Properties -->
      <div
        :class="{ 'justify-content-end': !dataSetup.name }"
        class="properties-field-button"
      >
        <button
          v-if="dataSetup.name"
          :disabled="showModalFieldLibrary"
          class="button-border"
          @click="deleteSourceField"
        >
          <i class="fa fa-trash" /> Delete
        </button>

        <div class="d-flex align-items-center">
          <button
            :disabled="showModalFieldLibrary"
            class="button-border mr-2"
            @click="submitForm(true)"
          >
            Close
          </button>

          <button
            :disabled="showModalFieldLibrary"
            class="button-blue"
            @click="submitForm(false)"
          >
            {{ fieldDetail && fieldDetail.field_ui_key ? 'Update' : 'Apply' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Properties -->
    <properties-field
      v-if="selectedField"
      :ref="idPropertiesGroup"
      :id="[...id, idPropertiesGroup]"
      :stack-level="2"
      :field-detail="selectedField"
      :variable-options="((dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'relation_record_external_api') && !isBulk && (!variableOptionsGroup || variableOptionsGroup.length === 0)) ? list_field : variableOptionsGroup"
      :field-ui-key="dataSetup.fieldGroup"
      :type="propertiesType"
      :parent-type="fieldDetail.type"
      :is-detail-view="isDetailView"
      :is-group="true"
      :is-new-field="isNewFieldGroup"
      :native-buttons="nativeButtons"
      @delete-field="deleteField"
      @close-properties="togglePropertiesField(false)"
      @submit-mode="submitField"
      @open-modal-full-script="openModalFullScript"
      @open-modal-company-drive="openModalCompanyDrive"
    />

    <!-- Properties Stack 3 -->
    <properties-field
      v-if="selectedSubField"
      :ref="idPropertiesSubGroup"
      :id="[...id, idPropertiesSubGroup]"
      :stack-level="3"
      :field-detail="selectedSubField"
      :variable-options="((dataSetup.type.id === 'relation_record' || dataSetup.type.id === 'relation_record_external_api') && !isBulk && (!variableOptionsGroup || variableOptionsGroup.length === 0)) ? list_field : variableOptionsGroup"
      :field-ui-key="dataSetup.fieldGroup"
      :type="propertiesSubType"
      :parent-type="fieldDetail.type"
      :is-detail-view="isDetailView"
      :is-group="true"
      :is-new-field="isNewFieldSubGroup"
      :native-buttons="nativeButtons"
      @delete-field="deleteField"
      @close-properties="togglePropertiesSubField(false)"
      @submit-mode="submitField"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-unused-vars, no-nested-ternary, no-console, no-else-return, arrow-body-style */
import { required, requiredIf, minLength } from 'vuelidate/lib/validators';
import { mapActions, mapState, mapMutations } from 'vuex';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import jwtDecode from 'jwt-decode';
import he from 'he';
// Mixins
import jMixConditionEditor from '@/mixins/jMixConditionEditor';
import jMixAutoScroll from '@/mixins/jMixAutoScroll';
// Components
import draggable from 'vuedraggable';
import jColorPicker from '@/components/color-picker/jColorPicker';
import jSwitch from '@/components/inputs/jSwitch';
import jMonacoEditor from '@/components/monaco-editor/jMonacoEditor';
import jDateTime from '@/components/inputs/jDateTime';
import jClockpicker from '@/components/inputs/jClockpicker';
import FieldPreview from '@/views/experience-manager-v2/partials/FieldPreview';
import PropertiesField from '@/views/experience-manager-v2/partials/PropertiesField';
// Data
import currency from '@/assets/file/currency.json';
import timezone from '@/assets/file/timezone.json';

export default {
  name: 'PropertiesField',

  components: {
    draggable,
    jColorPicker,
    jSwitch,
    jMonacoEditor,
    jDateTime,
    jClockpicker,
    FieldPreview,
    PropertiesField,
  },

  mixins: [jMixConditionEditor, jMixAutoScroll],

  props: {
    id: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'default',
    },
    stackLevel: {
      type: Number,
      default: 1,
    },
    parentType: {
      type: String,
      default: '',
    },
    fieldDetail: {
      type: Object,
      default: () => {},
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    variableOptionsWatermark: {
      type: Array,
      default: () => [],
    },
    fieldUiKey: {
      type: Array,
      default: () => [],
    },
    isDetailView: {
      type: Boolean,
      default: () => false,
    },
    isNewField: {
      type: Boolean,
      default: () => false,
    },
    isGroup: {
      type: Boolean,
      default: () => false,
    },
    isTableEditable: {
      type: Boolean,
      default: () => false,
    },
    isPageScreen: {
      type: Boolean,
      default: () => false,
    },
    nativeButtons: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      isFirstLoad: true,
      dataSetup: {
        name: null,
        placeholder: null,
        type: { id: 'text' },
        variable: null,
        isMandatory: false,
        isDisable: false,
        isHidden: false,
        key: null,
        locationType: 1,
        isShowMaps: false,
        timezone: null,
        options: [''],
        optionsObject: [
          { label: null, value: null },
        ],
        acceptedFileType: [],
        isUseCamera: false,
        isAutoFill: false,
        isWithParam: false,
        isAutoShow: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
          dataSelection: null,
          fieldReference: null,
        },
        filterColumn: null,
        fieldKey: null,
        sourceExternal: null,
        sourceExternalVariable: '',
        sourceExternalSetValue: null,
        fieldGroup: [],
        isDisableAddMore: false,
        isDisableDeleteRow: false,
        tags: [],
        sourceCamera: null,
        chooseCamera: null,
        html: '',
        isUseWatermark: false,
        field1: null,
        field2: null,
        field3: null,
        isValueChange: false,
        onValueChange: '',
        grid: null,
        filter: [
          {
            key: null,
            value: null,
          },
        ],
        filterOperator: null,
        sorting: { key: null, order: null },
        language: null,
        isDisableBackDate: false,
        width: null,
        defaultValue: null,
        isAllowSelectAllData: false,
        isAllowMinusValue: false,
        isAllowApproverUpdate: false,
        viewOptions: null,
        defaultCurrency: null,
        loadRate: null,
        isEditableRate: false,
        isAdditionalDataKey: false,
        additionalOriginAmount: null,
        additionalOriginCurrency: null,
        additionalConvertionAmount: null,
        additionalTargetCurrency: null,
        additionalRate: null,
        initialValue: {
          type: '',
          function_name: null,
          params: {},
          value: '',
        },
        sliderOptions: '',
        sliderMinimum: null,
        sliderMaximum: null,
        isDirectOpenDetail: false,
        formUiDirectOpenDetail: null,
        formatTextLabel: null,
        styleTextLabel: {
          heading: '',
          font: [],
          alignment: '',
        },
        linkTextLabel: '',
        progressBarColor: '#000000',
        viewStyleAttachment: 'list',
        isPrivateFile: false,
        companyDrivePath: '',
        enableCopyValue: false,
      },
      showFilterOptions: false,
      currentLocation: false,
      manualLocation: false,
      rearCamera: false,
      frontCamera: false,
      openEditor: false,
      editorOption: {},
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      listLocationType: [
        { id: 1, text: 'Current Location' },
        { id: 2, text: 'Manual Location' },
        { id: 3, text: 'All Type' },
      ],
      list_field_external: [
        { id: 'all', text: 'All' },
        { id: 'id', text: 'ID' },
      ],
      list_accepted_file_type: [
        { id: 'png', text: 'PNG' },
        { id: 'jpg', text: 'JPG' },
        { id: 'jpeg', text: 'JPEG' },
        { id: 'csv', text: 'CSV' },
        { id: 'txt', text: 'TXT' },
        { id: 'xls', text: 'XLS' },
        { id: 'xlsx', text: 'XLSX' },
        { id: 'docx', text: 'DOCX' },
        { id: 'doc', text: 'DOC' },
        { id: 'pdf', text: 'PDF' },
        { id: 'ppt', text: 'PPT' },
        { id: 'pptx', text: 'PPTX' },
        { id: 'mp4', text: 'MP4' },
      ],
      list_choose_camera: [
        { id: 1, text: 'Main & Selfie Camera' },
        { id: 2, text: 'Selfie Camera' },
        { id: 3, text: 'Main Camera' },
      ],
      list_source_camera: [
        { value: true, text: 'Camera & Gallery' },
        { value: false, text: 'Camera Only' },
      ],
      filterOperatorOptions: [
        {
          id: 'and',
          name: 'AND',
        },
        {
          id: 'or',
          name: 'OR',
        },
      ],
      orderOptions: [
        {
          id: 'asc',
          label: 'Ascending',
          text: 'Ascending',
        },
        {
          id: 'desc',
          label: 'Descending',
          text: 'Descending',
        },
      ],
      languageOptions: [
        {
          id: 'html',
          name: 'HTML',
        },
        {
          id: 'javascript',
          name: 'Javascript',
        },
      ],
      viewDynamicOptions: [
        {
          id: 'settings',
          name: 'SETTINGS',
        },
        {
          id: 'render',
          name: 'RENDER',
        },
      ],
      widthOptions: [
        { id: '50', name: '50' },
        { id: '100', name: '100' },
        { id: '150', name: '150' },
        { id: '200', name: '200' },
        { id: '250', name: '250' },
        { id: '300', name: '300' },
        { id: '350', name: '350' },
        { id: '400', name: '400' },
        { id: '450', name: '450' },
        { id: '500', name: '500' },
      ],
      listGrid: [
        { id: 12, text: 12 },
        { id: 11, text: 11 },
        { id: 10, text: 10 },
        { id: 9, text: 9 },
        { id: 8, text: 8 },
        { id: 7, text: 7 },
        { id: 6, text: 6 },
        { id: 5, text: 5 },
        { id: 4, text: 4 },
        { id: 3, text: 3 },
        { id: 2, text: 2 },
        { id: 1, text: 1 },
      ],
      list_field: [],
      list_field_key: [],
      list_field_class: [],
      list_field_for_issearch: [],
      list_field_data_selection: [],
      list_field_reference: [],
      tableGroupOptions: [],
      tableOptions: [],
      listFunction: [],
      finishSetDataTableGroup: false,

      // for group
      idPropertiesGroup: 'propertiesFieldGroup',
      isOpen: false,
      isNewFieldGroup: false,
      selectedField: null,
      selectedIndexField: null,
      propertiesType: null,
      variableOptionsGroup: [],

      // For sub group (stack 3)
      idPropertiesSubGroup: 'propertiesFieldSubGroup',
      isNewFieldSubGroup: false,
      selectedSubField: null,
      selectedIndexSubField: null,
      propertiesSubType: null,

      problemMessage: '',
      isError: false,
      darkMode: false,
      tabSelected: 'value',

      exampleOptionCurrency: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: 'Rp',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0',
        maximumValue: '99999999999999',
        negativePositiveSignPlacement: 'r',
        negativeBracketsTypeOnBlur: '(,)',
      },
      showDefaultCurrency: true,

      style_text_label: [
        {
          label: 'Heading',
          options: ['normal', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
        },
        {
          label: 'Font',
          options: ['bold', 'italic', 'underline'],
        },
        {
          label: 'Alignment',
          options: ['left', 'center', 'right'],
        },
      ],
      formatOptions: [
        {
          id: 'text',
          text: 'Text',
        },
        {
          id: 'number',
          text: 'Number',
        },
        {
          id: 'currency',
          text: 'Currency',
        },
        {
          id: 'datetime',
          text: 'Date Time',
        },
        {
          id: 'time',
          text: 'Time',
        },
        {
          id: 'dd-mmm-yyyy',
          text: 'Date (dd-mmm-yyyy)',
        },
        {
          id: 'mmmm dd, yyyy',
          text: 'Date (mmmm dd, yyyy)',
        },
      ],
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail', 'form_detail']),
    ...mapState('jStoreExperienceManagerV2', [
      'showModalFieldLibrary', 'showModalExternalApi', 'sourceExternalApi', 'sourceModalFieldLibrary',
      'targetStackedProperties', 'isBulk', 'isSearch', 'isDataset', 'valueOnChangeScript', 'valueCompanyDrivePath',
    ]),

    isHaveConfig() {
      if (this.dataSetup.type) {
        if (this.isTableEditable) {
          const typeNotConfig = ['text', 'time', 'number', 'number_decimal', 'currency', 'currency_selection', 'descriptive', 'user_single_selection', 'separator', 'timer', 'password', 'color'];
          return !typeNotConfig.includes(this.dataSetup.type.id);
        }
        if (this.isBulk || this.isSearch) {
          const typeNotConfig = ['text', 'date', 'time', 'date_time', 'number', 'number_decimal', 'currency', 'currency_selection', 'descriptive', 'user_single_selection', 'separator', 'timer', 'password', 'color', 'text_editor'];
          return !typeNotConfig.includes(this.dataSetup.type.id);
        }
        if (this.type === 'data_preview') {
          const typeNotConfig = ['text', 'date', 'time', 'date_time', 'number', 'number_decimal', 'descriptive', 'user_single_selection', 'separator', 'timer', 'password', 'color', 'text_editor'];
          return !typeNotConfig.includes(this.dataSetup.type.id);
        }
        if (this.isDataset) {
          return false;
        }
        if (this.dataSetup.type.id === 'dynamic_field' && (this.dataSetup.viewOptions === 'settings' || this.dataSetup.viewOptions === null)) {
          return false;
        }
        if (this.isDetailView && this.isApproverCanUpdate) {
          const typeNotConfig = ['separator'];
          return !typeNotConfig.includes(this.dataSetup.type.id);
        }
        if ((this.dataSetup.type.id === 'group' || this.dataSetup.type.id === 'table_group') && !this.dataSetup.variable) {
          return false;
        }
        const typeNotConfig = ['user_single_selection', 'separator', 'timer', 'digital_signature', 'color', 'text_editor'];
        return !typeNotConfig.includes(this.dataSetup.type.id);
      }
      return false;
    },

    isUsePlaceholder() {
      if (
        !this.isSearch && (
          !this.dataSetup.type.id.includes('attachment') &&
          this.dataSetup.type.id !== 'toggle' &&
          this.dataSetup.type.id !== 'checkbox' &&
          this.dataSetup.type.id !== 'radio' &&
          this.dataSetup.type.id !== 'timer' &&
          this.dataSetup.type.id !== 'separator' &&
          this.dataSetup.type.id !== 'custom_html' &&
          this.dataSetup.type.id !== 'code_editor' &&
          this.dataSetup.type.id !== 'color' &&
          this.dataSetup.type.id !== 'slider' &&
          this.dataSetup.type.id !== 'text_label' &&
          this.dataSetup.type.id !== 'digital_signature' &&
          this.dataSetup.type.id !== 'dynamic_field' &&
          this.dataSetup.type.id !== 'group' &&
          this.dataSetup.type.id !== 'table_group' &&
          this.dataSetup.type.id !== 'progress_bar'
        )
      ) {
        return true;
      }
      return false;
    },

    isUseGrid() {
      if (
        !this.isBulk && !this.isSearch && !this.isTableEditable && this.type !== 'group' && (
          this.dataSetup.type.id !== 'location' &&
          this.dataSetup.type.id !== 'color' &&
          this.dataSetup.type.id !== 'separator' &&
          this.dataSetup.type.id !== 'custom_html' &&
          this.dataSetup.type.id !== 'text_editor' &&
          this.dataSetup.type.id !== 'group' &&
          this.dataSetup.type.id !== 'table_group' &&
          this.dataSetup.type.id !== 'dynamic_field'
        )
      ) {
        return true;
      }
      return false;
    },

    isNoGrid() {
      if (this.dataSetup.type) {
        const typeNotGrid = ['location', 'attachment', 'multiple_attachment_dynamic', 'single_attachment', 'separator', 'custom_html', 'group', 'table_group', 'code_editor', 'digital_signature'];
        return typeNotGrid.includes(this.dataSetup.type.id) || ((this.dataSetup.type.id === 'radio' || this.dataSetup.type.id === 'checkbox') && this.dataSetup.optionsObject.length > 2) || this.isBulk || this.isTableEditable;
      }
      return false;
    },

    // eslint-disable-next-line consistent-return
    variableOptionsFiltered() {
      if (this.dataSetup.type && this.dataSetup.type.id === 'toggle') {
        return this.variableOptions.filter(f => f.type === 'boolean');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'user_single_selection' && !this.isSearch) {
        return this.variableOptions.filter(f => f.type === 'person');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'user_single_selection' && this.isSearch) {
        return this.variableOptions.filter(f => f.type === 'person' || f.label === 'created_by' || f.label === 'updated_by');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'timer') {
        return this.variableOptions.filter(f => f.type === 'timer');
      } else if (this.dataSetup.type &&
                this.dataSetup.type.id === 'single_tags_selection') {
        return this.variableOptions.filter(f => f.type === 'tags');
      } else if (this.dataSetup.type &&
                this.dataSetup.type.id === 'multiple_tags_selection') {
        return this.variableOptions.filter(f => f.type === '[]tags');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'multiple_attachment_dynamic' ||
                this.dataSetup.type.id === 'attachment')) {
        return this.variableOptions.filter(f => f.type === '[]attachment');
      } else if (this.dataSetup.type && !this.isDataset &&
                (this.dataSetup.type.id === 'radio' ||
                this.dataSetup.type.id === 'text' ||
                this.dataSetup.type.id === 'descriptive' ||
                this.dataSetup.type.id === 'single_selection' ||
                this.dataSetup.type.id === 'single_attachment' ||
                this.dataSetup.type.id === 'password' ||
                this.dataSetup.type.id === 'digital_signature' ||
                this.dataSetup.type.id === 'color' ||
                this.dataSetup.type.id === 'code_editor' ||
                (this.dataSetup.type.id === 'slider' && this.dataSetup.sliderOptions === 'string'))) {
        return this.variableOptions.filter(f => f.type === 'text');
      } else if (this.dataSetup.type && this.isDataset &&
                (this.dataSetup.type.id === 'text' ||
                this.dataSetup.type.id === 'descriptive' ||
                this.dataSetup.type.id === 'single_selection')) {
        return this.variableOptions.filter(f => f.type === 'text' || f.type === 'varchar');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'checkbox' ||
                this.dataSetup.type.id === 'multiple_selection') && !this.isSearch) {
        return this.variableOptions.filter(f => f.type === '[]text');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'multiple_selection' && this.isSearch) {
        return this.variableOptions.filter(f => f.type === '[]text' || f.type === 'text');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'number' ||
                this.dataSetup.type.id === 'number_decimal' ||
                this.dataSetup.type.id === 'currency' ||
                this.dataSetup.type.id === 'progress_bar' ||
                (this.dataSetup.type.id === 'slider' && this.dataSetup.sliderOptions === 'range'))) {
        return this.variableOptions.filter(f => f.type === 'number' || f.type === 'integer' || f.type === 'big_integer' || f.type === 'small_integer');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'date' ||
                this.dataSetup.type.id === 'date_time' ||
                this.dataSetup.type.id === 'time')) {
        return this.variableOptions.filter(f => f.type === 'timestamp');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'location') {
        return this.variableOptions.filter(f => f.type === 'maps');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'relation_record' ||
                this.dataSetup.type.id === 'relation_record_external_api' ||
                this.dataSetup.type.id === 'text_editor' ||
                this.dataSetup.type.id === 'currency_selection')) {
        if (this.isDataset) {
          return this.variableOptions.filter(f => f.type === 'text' || f.type === 'varchar');
        } else {
          return this.variableOptions.filter(f => f.type === 'object');
        }
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'multiple_relation_record' ||
                this.dataSetup.type.id === 'multiple_relation_record_external_api') && !this.isDataset) {
        return this.variableOptions.filter(f => f.type === '[]object');
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'multiple_relation_record' ||
                this.dataSetup.type.id === 'multiple_relation_record_external_api') && this.isDataset) {
        return this.variableOptions;
      } else if (this.dataSetup.type &&
                (this.dataSetup.type.id === 'group' ||
                this.dataSetup.type.id === 'table_group')) {
        return this.variableOptions.filter(f => f.type === `[]${f.id}`);
      } else if (this.dataSetup.type &&
                this.dataSetup.type.id === 'dynamic_field' &&
                this.dataSetup.viewOptions === 'settings') {
        return this.variableOptions.filter(f => f.type === '[]object');
      } else if (this.dataSetup.type &&
                this.dataSetup.type.id === 'dynamic_field' &&
                this.dataSetup.viewOptions === 'render') {
        return this.variableOptions.filter(f => f.type === 'object');
      } else if (this.dataSetup.type && this.dataSetup.type.id === 'text_label') {
        if (this.dataSetup.formatTextLabel === 'text') {
          return this.variableOptions.filter(f => f.type === 'text' || f.type === 'varchar');
        } else if (this.dataSetup.formatTextLabel === 'number' || this.dataSetup.formatTextLabel === 'currency') {
          return this.variableOptions.filter(f => f.type === 'number' || f.type === 'integer' || f.type === 'big_integer' || f.type === 'small_integer');
        } else if (this.dataSetup.formatTextLabel === 'datetime' ||
                this.dataSetup.formatTextLabel === 'time' ||
                this.dataSetup.formatTextLabel === 'dd-mmm-yyyy' ||
                this.dataSetup.formatTextLabel === 'mmmm dd, yyyy') {
          return this.variableOptions.filter(f => f.type === 'timestamp');
        }
      }
    },

    defaultTags() {
      return [{
        name: '',
        background: '#000000',
        font_color: '#000000',
      }];
    },

    // Computed for property location
    propertyLocation() {
      return `${this.currentLocation}|${this.manualLocation}`;
    },

    // Computed for property maps
    propertyCamera() {
      return `${this.rearCamera}|${this.frontCamera}`;
    },

    propertyTitle() {
      if (this.fieldDetail.type === 'attachment') return 'Multiple Attachment';
      if (this.fieldDetail.type === 'multiple_attachment_dynamic') return 'Dynamic Attachment';
      if (this.fieldDetail.type === 'descriptive') return 'Text Area';
      if (this.fieldDetail.type === 'location') return 'Maps';
      if (this.fieldDetail.type === 'custom_html') return 'Custom HTML';
      if (this.fieldDetail.type === 'relation_record_external_api') return 'Relation Record External API';
      if (this.fieldDetail.type === 'multiple_relation_record_external_api') return 'Multiple Relation Record External API';
      return this.fieldDetail.type === 'attachment' ? 'Multiple Attachment' : this.fieldDetail.type.split('_').join(' ');
    },

    isApproverCanUpdate() {
      return !(this.nativeButtons && this.nativeButtons.approveUpdate && this.nativeButtons.approveUpdate.is_hidden) && typeof this.nativeButtons !== 'undefined';
    },

    list_currency() {
      const listKey = Object.keys(currency);
      const listValue = Object.values(currency);
      return listValue.map((e, index) => {
        e.id = listKey[index];
        e.symbol_name = `${e.symbol} - ${e.name}`;
        return e;
      });
    },

    listTimezone() {
      return timezone.map((zone) => {
        // eslint-disable-next-line no-param-reassign
        zone.id = zone.utc;
        return zone;
      });
    },

    isShowInitialValue() {
      return !this.isSearch && !this.isBulk && !this.isDataset &&
      !this.isTableEditable && (this.type === 'default' ||
      this.type === 'group') &&
      (this.dataSetup.type.id === 'text' ||
      this.dataSetup.type.id === 'descriptive' ||
      this.dataSetup.type.id === 'number' ||
      this.dataSetup.type.id === 'number_decimal' ||
      this.dataSetup.type.id === 'date' ||
      this.dataSetup.type.id === 'time' ||
      this.dataSetup.type.id === 'date_time' ||
      this.dataSetup.type.id === 'currency' ||
      this.dataSetup.type.id === 'currency_selection' ||
      this.dataSetup.type.id === 'single_selection' ||
      this.dataSetup.type.id === 'relation_record' ||
      this.dataSetup.type.id === 'relation_record_external_api' ||
      this.dataSetup.type.id === 'progress_bar');
    },

    useConfigPrivateStorage() {
      return Number(process.env.RLS_PRIVATE_STORAGE) === 1 &&
        (this.dataSetup.type.id === 'attachment' ||
        this.dataSetup.type.id === 'multiple_attachment_dynamic' ||
      this.dataSetup.type.id === 'single_attachment');
    },

    useConfigEnableCopyValue() {
      return Number(process.env.RLS_COPY_VALUE) === 1 && this.dataSetup.type.id === 'descriptive';
    },
  },

  watch: {
    // eslint-disable-next-line
    'dataSetup.sourceData.tableGroup': function (val) {
      if (this.finishSetDataTableGroup) {
        this.dataSetup.sourceData.form = null;
        this.list_field = [];
        this.list_field_class = [];
        this.list_field_for_issearch = [];
        this.list_field_data_selection = [];
        this.dataSetup.sourceData.setValue = null;
        this.dataSetup.sourceData.showData = null;
        this.dataSetup.sourceData.searchData = null;
        this.dataSetup.filter = [];
        this.dataSetup.filterColumn = null;
        this.dataSetup.sorting = { key: null, order: null };
        this.dataSetup.sourceData.dataSelection = null;
      }
      setTimeout(() => { this.$v.dataSetup.$reset(); }, 10);

      if (val) {
        const reqTable = {
          tablegroup_id: val.id,
          search: '',
        };
        this.getListTableByGroupV2(reqTable).then((res) => {
          if (!res.error) {
            this.tableOptions = res.data || [];
          }
        });
      }
    },

    // eslint-disable-next-line
    'dataSetup.sourceData.form': function(data) {
      if (this.fieldDetail) {
        const listColumns = Object.keys(data.columns);
        const listColumnsVal = Object.values(data.columns);
        this.list_field = listColumnsVal.map((e) => {
          e.id = e.name;
          e.text = e.name;
          e.label = e.name;
          return e;
        });

        this.list_field_for_issearch = listColumnsVal.filter(f => f.type === 'object').map((e) => {
          e.id = e.name;
          e.text = e.name;
          e.label = e.name;
          return e;
        });

        this.list_field_data_selection = listColumnsVal.filter(f => f.type === '[]object').map((e) => {
          e.id = e.name;
          e.text = e.name;
          e.label = e.name;
          return e;
        });

        this.list_field_class = [];
        if (listColumns.length > 0) {
          listColumns.forEach((column, index) => {
            if (listColumnsVal[index].type !== '[]attachment') {
              if (listColumnsVal[index].type === 'person') {
                this.list_field_class.push({
                  id: `${column}.company_user_id`,
                  label: `${column}.company_user_id`,
                  text: `${column}.company_user_id`,
                });
                this.list_field_class.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                });
                this.list_field_class.push({
                  id: `${column}.email`,
                  label: `${column}.email`,
                  text: `${column}.email`,
                });
              } else if (listColumnsVal[index].type === 'object') {
                this.list_field_class.push({
                  id: `${column}.id`,
                  label: `${column}.id`,
                  text: `${column}.id`,
                });
                this.list_field_class.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                });
              } else if (listColumnsVal[index].type === 'timer') {
                this.list_field_class.push({
                  id: `${column}.state`,
                  label: `${column}.state`,
                  text: `${column}.state`,
                });
                this.list_field_class.push({
                  id: `${column}.duration`,
                  label: `${column}.duration`,
                  text: `${column}.duration`,
                });
              } else if (listColumnsVal[index].type === 'tags') {
                this.list_field_class.push({
                  id: `${column}.name`,
                  label: `${column}.name`,
                  text: `${column}.name`,
                });
                this.list_field_class.push({
                  id: `${column}.background`,
                  label: `${column}.background`,
                  text: `${column}.background`,
                });
                this.list_field_class.push({
                  id: `${column}.font_color`,
                  label: `${column}.font_color`,
                  text: `${column}.font_color`,
                });
              } else if (listColumnsVal[index].type === 'maps') {
                this.list_field_class.push({
                  id: `${column}.latitude`,
                  label: `${column}.latitude`,
                  text: `${column}.latitude`,
                });
                this.list_field_class.push({
                  id: `${column}.longitude`,
                  label: `${column}.longitude`,
                  text: `${column}.longitude`,
                });
                this.list_field_class.push({
                  id: `${column}.address`,
                  label: `${column}.address`,
                  text: `${column}.address`,
                });
              }
              // else {
              this.list_field_class.push({
                id: column,
                label: column,
                text: column,
              });
              // }
            }
          });
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.key': function (val){
      if (this.fieldDetail) {
        const regexSymbol = /[^\w\s]/g;
        setTimeout(() => {
          this.dataSetup.key = val ?
            val.toLowerCase()
              .replace(regexSymbol, '')
              .replace(' ', '_') : null;
        }, 1);
      }
    },

    // eslint-disable-next-line
    'dataSetup.variable': function (val){
      if (this.fieldDetail && this.form_data_detail.length > 0) {
        const classGroup = this.form_data_detail[0].class[val.id];
        if (classGroup) {
          const dataColumns = Object.values(classGroup);
          this.variableOptionsGroup = dataColumns.map((e) => {
            e.id = e.name;
            e.text = e.name;
            e.label = e.name;
            e.type = e.type;
            return e;
          });
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.isUseWatermark': function (val){
      if (this.fieldDetail) {
        this.dataSetup.field1 = null;
        this.dataSetup.field2 = null;
        this.dataSetup.field3 = null;
      }
    },

    // eslint-disable-next-line
    'dataSetup.type': function (val){
      if (this.fieldDetail) {
        if (val) {
          const typeNotGrid = ['location', 'attachment', 'multiple_attachment_dynamic', 'single_attachment', 'separator', 'custom_html', 'group', 'table_group', 'code_editor', 'digital_signature'];
          if (typeNotGrid.includes(val.id) || this.isBulk || this.isTableEditable) {
            this.dataSetup.grid = 12;
          } else {
            this.dataSetup.grid = null;
          }
        }
        this.dataSetup.defaultValue = null;
      }
    },

    // eslint-disable-next-line
    'dataSetup.optionsObject': function (val){
      if (val.length === 0) {
        if ((this.dataSetup.type && (this.dataSetup.type.id === 'radio' || this.dataSetup.type.id === 'checkbox')) || this.isBulk || this.isTableEditable) {
          this.dataSetup.optionsObject = [{ label: null, value: null }];
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.options': function (val) {
      if (this.dataSetup.type && (
        this.dataSetup.type.id === 'single_selection' ||
        this.dataSetup.type.id === 'multiple_selection' ||
        this.dataSetup.type.id === 'photo' ||
        this.dataSetup.type.id === 'attachment'
      )) {
        if (val.length === 0) {
          this.dataSetup.options = [''];
        }
      }
    },

    // eslint-disable-next-line
    'dataSetup.grid': function () {
      this.submitPreview();
    },
    // eslint-disable-next-line
    'dataSetup.name': function () {
      this.submitPreview();
    },
    // eslint-disable-next-line
    'dataSetup.placeholder': function () {
      this.submitPreview();
    },

    // eslint-disable-next-line
    'dataSetup.initialValue.type': function (val) {
      if (!val) {
        this.dataSetup.initialValue = {
          type: '',
          function_name: null,
          params: {},
          value: '',
        };
      } else if (val === 'static_value') {
        this.dataSetup.initialValue.params = [];
        this.dataSetup.initialValue.function_name = null;
      } else if (val === 'function') {
        this.dataSetup.initialValue.value = '';
      }
    },

    // Set data location to dataSetup
    propertyLocation(val) {
      const splitVal = val.split('|');
      const currentLoc = splitVal[0];
      const manualLoc = splitVal[1];

      if (currentLoc === 'false' && manualLoc === 'false') {
        this.dataSetup.locationType = 0;
      } else if (currentLoc === 'true' && manualLoc === 'false') {
        this.dataSetup.locationType = 1;
      } else if (currentLoc === 'false' && manualLoc === 'true') {
        this.dataSetup.locationType = 2;
      } else if (currentLoc === 'true' && manualLoc === 'true') {
        this.dataSetup.locationType = 3;
      }
    },

    // Set data maps to dataSetup
    propertyCamera(val) {
      const splitVal = val.split('|');
      const rearCam = splitVal[0];
      const frontCam = splitVal[1];

      if (rearCam === 'false' && frontCam === 'false') {
        this.dataSetup.chooseCamera = null;
        this.dataSetup.isUseCamera = false;
      } else if (rearCam === 'true' && frontCam === 'false') {
        this.dataSetup.chooseCamera = 3;
        this.dataSetup.isUseCamera = true;
      } else if (rearCam === 'false' && frontCam === 'true') {
        this.dataSetup.chooseCamera = 2;
        this.dataSetup.isUseCamera = true;
      } else if (rearCam === 'true' && frontCam === 'true') {
        this.dataSetup.chooseCamera = 1;
        this.dataSetup.isUseCamera = true;
      }
    },

    // Watch state for relation record ext api
    showModalExternalApi(val) {
      if (!val) {
        const target = this.targetStackedProperties;
        if (target === this.stackLevel) {
          const dataSource = this.$parent.$refs[this.id[this.stackLevel - 1]].dataSetup;
          if (this.sourceExternalApi) dataSource.sourceExternal = this.sourceExternalApi;
        }
      }
    },

    // Watch state if select field in modal field library
    sourceModalFieldLibrary: {
      handler(val) {
        const target = this.targetStackedProperties;
        if (val) {
          setTimeout(() => {
            if (this.stackLevel === 2 && this.stackLevel === target) {
              const index = this.dataSetup.fieldGroup.push(val) - 1;
              this.selectedSubField = this.dataSetup.fieldGroup[index];
              this.selectedIndexSubField = index;
              this.isNewFieldSubGroup = true;

              setTimeout(() => {
                this.togglePropertiesSubField(true);
              }, 200);
            } else if (this.stackLevel !== 2 && this.stackLevel === target) {
              const index = this.dataSetup.fieldGroup.push(val) - 1;
              this.selectedField = this.dataSetup.fieldGroup[index];
              this.selectedIndexField = index;
              this.isNewFieldGroup = true;

              setTimeout(() => {
                this.togglePropertiesField(true);
              }, 200);
            }

            this.setSourceModalFieldLibrary(null);
          }, 200);
        }
      },
      deep: true,
    },

    showModalFieldLibrary(val) {
      if (!val) {
        this.setIsFieldGroup(false);
        this.setIsTableGroup(false);
        this.setIsDataPreview(false);
        this.setIsDataPreviewGroup(false);
      }
    },

    isPageScreen() {
      this.dataSetup.viewOptions = null;
    },

    valueOnChangeScript(val) {
      this.openEditor = false;
      this.dataSetup.onValueChange = val;
      setTimeout(() => {
        this.openEditor = true;
      }, 100);
    },

    valueCompanyDrivePath(val) {
      if (val) this.dataSetup.companyDrivePath = val.replaceAll('"', '');
    },
  },

  created() {
    this.getListGroupTable();
    this.openEditor = false;
    this.dataSetup.type = { id: this.fieldDetail.type };
    const fieldDetail = this._.cloneDeep(this.fieldDetail);

    if (fieldDetail) {
      this.dataSetup = {
        type: { id: fieldDetail.type },
        name: this.isNewField ? '' : fieldDetail.name,
        placeholder: fieldDetail.placeholder || null,
        variable: fieldDetail.field_data_key ? (this.parentType.includes('external_api') ? fieldDetail.field_data_key : { id: fieldDetail.field_data_key }) : null,
        isMandatory: fieldDetail.is_mandatory || false,
        isDisable: this.type === 'data_preview' ? true : fieldDetail.is_disable,
        isHidden: fieldDetail.is_hidden || false,
        key: fieldDetail.field_ui_key,
        locationType: fieldDetail.type === 'location' ? (fieldDetail.config ? fieldDetail.config.map_type : 1) : 1,
        isShowMaps: fieldDetail.type === 'location' ? (fieldDetail.config ? fieldDetail.config.is_show_maps : false) : false,
        options: fieldDetail.type === 'single_selection' ||
            fieldDetail.type === 'multiple_selection' ||
            fieldDetail.type === 'photo' ||
            fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'radio' ||
            fieldDetail.type === 'checkbox' ||
            fieldDetail.type === 'slider' ? (fieldDetail.config ? fieldDetail.config.list_options : ['']) : [''],
        optionsObject: fieldDetail.type === 'radio' || fieldDetail.type === 'checkbox' ? (fieldDetail.config ? fieldDetail.config.list_options_object : [{ label: null, value: null }]) : [{ label: null, value: null }],
        acceptedFileType: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.accepted_file_type : []) : [],
        isUseCamera: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.is_use_camera : false) : false,
        isAutoFill: fieldDetail.type === 'relation_record' || fieldDetail.type === 'relation_record_external_api' ? (fieldDetail.config ? fieldDetail.config.is_auto_fill : false) : false,
        isWithParam: fieldDetail.type === 'relation_record' || fieldDetail.type === 'multiple_relation_record' ? (fieldDetail.config ? fieldDetail.config.is_with_param : false) : false,
        isAutoShow: fieldDetail.type === 'relation_record' ||
                    fieldDetail.type === 'multiple_relation_record' ||
                    fieldDetail.type === 'relation_record_external_api' ||
                    fieldDetail.type === 'multiple_relation_record_external_api' ? (fieldDetail.config ? fieldDetail.config.is_auto_show : false) : false,
        sourceData: {
          tableGroup: fieldDetail.type === 'relation_record' || fieldDetail.type === 'multiple_relation_record' ||
            (fieldDetail.type === 'dynamic_field' && fieldDetail.config && fieldDetail.config.view_options === 'render') ? (fieldDetail.config ? fieldDetail.config.data_source.table_group : null) : null,
          form: fieldDetail.type === 'relation_record' || fieldDetail.type === 'multiple_relation_record' ||
            (fieldDetail.type === 'dynamic_field' && fieldDetail.config && fieldDetail.config.view_options === 'render') ? (fieldDetail.config ? fieldDetail.config.data_source.form : null) : null,
          showData: fieldDetail.type === 'relation_record' ||
            fieldDetail.type === 'multiple_relation_record' ? (fieldDetail.config ? fieldDetail.config.data_source.show_data_option : null) : null,
          searchData: fieldDetail.type === 'relation_record' ||
            fieldDetail.type === 'multiple_relation_record' ? (fieldDetail.config ? fieldDetail.config.data_source.search_data_option : null) : null,
          setValue: fieldDetail.type === 'relation_record' ||
            fieldDetail.type === 'multiple_relation_record' ? (fieldDetail.config ? fieldDetail.config.data_source.set_value_selected : null) : null,
          dataSelection: fieldDetail.type === 'dynamic_field' && fieldDetail.config && fieldDetail.config.view_options === 'render' ?
            (fieldDetail.config && fieldDetail.config.data_source ? fieldDetail.config.data_source.data_selection : null) : null,
          fieldReference: fieldDetail.type === 'dynamic_field' && fieldDetail.config && fieldDetail.config.view_options === 'render' ?
            (fieldDetail.config ? fieldDetail.config.field_reference : null) : null,
        },
        filterColumn: fieldDetail.type === 'relation_record' || fieldDetail.type === 'multiple_relation_record' ? (fieldDetail.config ? fieldDetail.config.filter_column : null) : null,
        fieldKey: fieldDetail.type === 'relation_record' || fieldDetail.type === 'multiple_relation_record' ? (fieldDetail.config ? fieldDetail.config.field_key : null) : null,
        sourceExternal: fieldDetail.type === 'relation_record_external_api' ||
            fieldDetail.type === 'multiple_relation_record_external_api' ? (fieldDetail.config ? fieldDetail.config.data_source_external : null) : null,
        sourceExternalVariable: fieldDetail.type === 'relation_record_external_api' ||
            fieldDetail.type === 'multiple_relation_record_external_api' ? (fieldDetail.config ? fieldDetail.config.data_source_external_variable : null) : '',
        sourceExternalSetValue: fieldDetail.type === 'relation_record_external_api' ||
            fieldDetail.type === 'multiple_relation_record_external_api' ? (fieldDetail.config ? fieldDetail.config.data_source_external_set_value : null) : null,
        fieldGroup: fieldDetail.type === 'group' || fieldDetail.type === 'table_group' ? (fieldDetail.config ? fieldDetail.config.data_field_group : []) :
          (fieldDetail.type === 'relation_record' || fieldDetail.type === 'relation_record_external_api' ? (fieldDetail.config ? fieldDetail.config.data_field_auto : []) : []),
        isDisableAddMore: fieldDetail.type === 'group' || fieldDetail.type === 'table_group' ? (fieldDetail.config ? fieldDetail.config.is_disable_add_more : false) : false,
        isDisableDeleteRow: fieldDetail.type === 'group' || fieldDetail.type === 'table_group' ? (fieldDetail.config ? fieldDetail.config.is_disable_delete_row : false) : false,
        tags: fieldDetail.type === 'single_tags_selection' || fieldDetail.type === 'multiple_tags_selection' ? (fieldDetail.config ? fieldDetail.config.list_tags : this.defaultTags) : this.defaultTags,
        sourceCamera: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.is_can_access_gallery : true) : true,
        chooseCamera: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.camera_type : null) : null,
        html: fieldDetail.type === 'custom_html' ? (fieldDetail.config ? he.decode(fieldDetail.config.html) : '') : '',
        isUseWatermark: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.is_use_watermark : false) : false,
        field1: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.field_1 : null) : null,
        field2: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.field_2 : null) : null,
        field3: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.field_3 : null) : null,
        isValueChange: (fieldDetail.type === 'number' ||
                        fieldDetail.type === 'number_decimal' ||
                        fieldDetail.type === 'currency' ||
                        fieldDetail.type === 'currency_selection' ||
                        fieldDetail.type === 'single_selection' ||
                        fieldDetail.type === 'text' ||
                        fieldDetail.type === 'date' ||
                        fieldDetail.type === 'time' ||
                        fieldDetail.type === 'date_time' ||
                        fieldDetail.type === 'relation_record' ||
                        fieldDetail.type === 'relation_record_external_api' ||
                        fieldDetail.type === 'radio' ||
                        fieldDetail.type === 'checkbox' ||
                        fieldDetail.type === 'toggle' ||
                        fieldDetail.type === 'password' ||
                        fieldDetail.type === 'single_attachment' ||
                        fieldDetail.type === 'descriptive' ||
                        fieldDetail.type === 'slider') && fieldDetail.config ? fieldDetail.config.is_value_change : false,
        onValueChange: (fieldDetail.type === 'number' ||
                        fieldDetail.type === 'number_decimal' ||
                        fieldDetail.type === 'currency' ||
                        fieldDetail.type === 'currency_selection' ||
                        fieldDetail.type === 'single_selection' ||
                        fieldDetail.type === 'text' ||
                        fieldDetail.type === 'date' ||
                        fieldDetail.type === 'time' ||
                        fieldDetail.type === 'date_time' ||
                        fieldDetail.type === 'relation_record' ||
                        fieldDetail.type === 'relation_record_external_api' ||
                        fieldDetail.type === 'radio' ||
                        fieldDetail.type === 'checkbox' ||
                        fieldDetail.type === 'toggle' ||
                        fieldDetail.type === 'password' ||
                        fieldDetail.type === 'single_attachment' ||
                        fieldDetail.type === 'descriptive' ||
                        fieldDetail.type === 'slider') && fieldDetail.config ? fieldDetail.config.on_value_change : '',
        grid: fieldDetail.grid_size ? fieldDetail.grid_size : this.checkType(),
        filter: [{ key: null, value: null }],
        filterOperator: fieldDetail.type === 'relation_record' || fieldDetail.type === 'multiple_relation_record' ||
          (fieldDetail.type === 'dynamic_field' && fieldDetail.config && fieldDetail.config.view_options === 'render') ? (fieldDetail.config ? fieldDetail.config.filter_operator : null) : null,
        sorting: { key: null, order: null },
        language: fieldDetail.type === 'code_editor' ? (fieldDetail.config ? fieldDetail.config.language : null) : null,
        isDisableBackDate: (fieldDetail.type === 'date' || fieldDetail.type === 'date_time') && fieldDetail.config ? fieldDetail.config.is_disable_back_date : false,
        defaultValue: null,
        isAllowSelectAllData: (fieldDetail.type === 'multiple_relation_record' || fieldDetail.type === 'multiple_relation_record_external_api') && fieldDetail.config ? fieldDetail.config.allow_select_all_data : false,
        isAllowMinusValue: (fieldDetail.type === 'currency' || fieldDetail.type === 'currency_selection') && fieldDetail.config ? fieldDetail.config.allow_minus_value : false,
        isAllowApproverUpdate: fieldDetail.config ? (fieldDetail.config.allow_approver_update || false) : false,
        viewOptions: fieldDetail.type === 'dynamic_field' && fieldDetail.config ? fieldDetail.config.view_options : null,
        defaultCurrency: fieldDetail.config ? fieldDetail.config.default_currency : null,
        loadRate: fieldDetail.type === 'currency_selection' && fieldDetail.config ? fieldDetail.config.load_rate : null,
        isEditableRate: fieldDetail.type === 'currency_selection' && fieldDetail.config ? fieldDetail.config.editable_rate : false,
        isAdditionalDataKey: fieldDetail.type === 'currency_selection' && fieldDetail.config ? fieldDetail.config.is_use_additional_data_key : false,
        additionalOriginAmount: fieldDetail.type === 'currency_selection' && fieldDetail.config && fieldDetail.config.additional_data_key ? { id: fieldDetail.config.additional_data_key.origin_amount } : null,
        additionalOriginCurrency: fieldDetail.type === 'currency_selection' && fieldDetail.config && fieldDetail.config.additional_data_key ? { id: fieldDetail.config.additional_data_key.origin_currency } : null,
        additionalConvertionAmount: fieldDetail.type === 'currency_selection' && fieldDetail.config && fieldDetail.config.additional_data_key ? { id: fieldDetail.config.additional_data_key.convertion_amount } : null,
        additionalTargetCurrency: fieldDetail.type === 'currency_selection' && fieldDetail.config && fieldDetail.config.additional_data_key ? { id: fieldDetail.config.additional_data_key.target_currency } : null,
        additionalRate: fieldDetail.type === 'currency_selection' && fieldDetail.config && fieldDetail.config.additional_data_key ? { id: fieldDetail.config.additional_data_key.rate } : null,
        timezone: fieldDetail.config && fieldDetail.config.timezone ?
          { ...fieldDetail.config.timezone, id: fieldDetail.config.timezone.utc } :
          null,
        initialValue: this.setInitialValue(fieldDetail),
        sliderOptions: fieldDetail.type === 'slider' && fieldDetail.config && fieldDetail.config.slider_type ? fieldDetail.config.slider_type : '',
        sliderMinimum: fieldDetail.type === 'slider' && fieldDetail.config && fieldDetail.config.list_options.length ? fieldDetail.config.list_options[0] : null,
        sliderMaximum: fieldDetail.type === 'slider' && fieldDetail.config && fieldDetail.config.list_options.length ? fieldDetail.config.list_options[1] : null,
        isDirectOpenDetail: (fieldDetail.type === 'relation_record' || fieldDetail.type === 'relation_record_external_api') &&
          fieldDetail.config && fieldDetail.config.direct_open_detail ? fieldDetail.config.direct_open_detail.is_use_direct_open_detail : false,
        formUiDirectOpenDetail: null,
        formatTextLabel: fieldDetail.type === 'text_label' && fieldDetail.config && fieldDetail.config.format_label ? fieldDetail.config.format_label : null,
        styleTextLabel: fieldDetail.type === 'text_label' && fieldDetail.config && fieldDetail.config.style_label ? fieldDetail.config.style_label : {
          heading: '',
          font: [],
          alignment: '',
        },
        linkTextLabel: fieldDetail.type === 'text_label' && fieldDetail.config && fieldDetail.config.link_label ? fieldDetail.config.link_label : '',
        progressBarColor: fieldDetail.type === 'progress_bar' && fieldDetail.config && fieldDetail.config.color ? fieldDetail.config.color : '#000000',
        viewStyleAttachment: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config && fieldDetail.config.view_style ? fieldDetail.config.view_style : 'list') : 'list',
        isPrivateFile: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.private_file : false) : false,
        companyDrivePath: fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.companydrive_path : '') : '',
        enableCopyValue: fieldDetail.type === 'descriptive' ? (fieldDetail.config ? fieldDetail.config.enable_copy_value : false) : false,
      };
      if (this.isGroup && this.parentType === 'table_group') {
        this.dataSetup.width = fieldDetail.config ? (fieldDetail.config ? fieldDetail.config.width : null) : null;
      }
      setTimeout(() => {
        this.dataSetup.sourceCamera = fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.is_can_access_gallery : true) : true;
        this.dataSetup.chooseCamera = fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.camera_type : null) : null;
        this.dataSetup.field1 = fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.field_1 : null) : null;
        this.dataSetup.field2 = fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.field_2 : null) : null;
        this.dataSetup.field3 = fieldDetail.type === 'attachment' ||
            fieldDetail.type === 'multiple_attachment_dynamic' ||
            fieldDetail.type === 'single_attachment' ? (fieldDetail.config ? fieldDetail.config.field_3 : null) : null;
        this.dataSetup.grid = fieldDetail.grid_size ? fieldDetail.grid_size : this.checkType();
        this.dataSetup.defaultValue = this.setDefaultValue((fieldDetail.config ? fieldDetail.config.default_value : null), fieldDetail.type);
      }, 500);
      if (fieldDetail.config && fieldDetail.config.sort) {
        const keySort = Object.keys(fieldDetail.config.sort[0]);
        const valueSort = Object.values(fieldDetail.config.sort[0]);

        this.dataSetup.sorting = {
          key: { id: keySort[0] },
          order: valueSort[0] === 1 ? { id: 'asc' } : { id: 'desc' },
        };
      }
      if (fieldDetail.config && fieldDetail.config.filter) {
        const keyFilter = Object.keys(fieldDetail.config.filter);
        const valueFilter = Object.values(fieldDetail.config.filter);
        if (keyFilter.length > 0) {
          this.dataSetup.filter = [];
          keyFilter.forEach((e, index) => {
            this.dataSetup.filter.push({
              key: { id: e },
              value: valueFilter[index],
            });
          });
        }
      }
      if ((fieldDetail.type === 'relation_record' || fieldDetail.type === 'relation_record_external_api') &&
          fieldDetail.config && fieldDetail.config.direct_open_detail && fieldDetail.config.direct_open_detail.form_ui_id) {
        const dataFilter = {
          id: fieldDetail.config.direct_open_detail.form_ui_id,
          company_id: this.session.user.company_id,
        };
        const reqData = {
          limit: 5,
          page: 1,
          filter: JSON.stringify(dataFilter),
        };
        this.findFormUi(reqData).then((res) => {
          const dataFormUi = res[0];
          dataFormUi.label = dataFormUi.name;
          this.dataSetup.formUiDirectOpenDetail = dataFormUi;
        });
      }
    } else {
      this.dataSetup = {
        name: null,
        placeholder: null,
        variable: null,
        isMandatory: false,
        isDisable: this.isDataset,
        isHidden: false,
        key: null,
        locationType: 1,
        isShowMaps: false,
        options: [''],
        optionsObject: [
          { label: null, value: null },
        ],
        acceptedFileType: [],
        isUseCamera: false,
        isAutoFill: false,
        isWithParam: false,
        isAutoShow: false,
        sourceData: {
          tableGroup: null,
          form: null,
          showData: null,
          searchData: null,
          setValue: null,
          dataSelection: null,
          fieldReference: null,
        },
        filterColumn: null,
        fieldKey: null,
        sourceExternal: null,
        sourceExternalVariable: '',
        sourceExternalSetValue: null,
        fieldGroup: [],
        isDisableAddMore: false,
        isDisableDeleteRow: false,
        tags: [
          {
            name: '',
            background: '#000000',
            font_color: '#000000',
          },
        ],
        sourceCamera: null,
        chooseCamera: null,
        html: '',
        isUseWatermark: false,
        field1: null,
        field2: null,
        field3: null,
        isValueChange: false,
        onValueChange: '',
        grid: null,
        filter: [{ key: null, value: null }],
        filterOperator: null,
        sorting: { key: null, order: null },
        language: null,
        isDisableBackDate: false,
        defaultValue: null,
        width: null,
        isAllowSelectAllData: false,
        isAllowMinusValue: false,
        isAllowApproverUpdate: false,
        viewOptions: null,
        defaultCurrency: null,
        loadRate: null,
        isEditableRate: false,
        isAdditionalDataKey: false,
        additionalOriginAmount: null,
        additionalOriginCurrency: null,
        additionalConvertionAmount: null,
        additionalTargetCurrency: null,
        additionalRate: null,
        initialValue: {
          type: '',
          function_name: null,
          params: [],
          value: '',
        },
        sliderOptions: '',
        sliderMinimum: null,
        sliderMaximum: null,
        isDirectOpenDetail: false,
        formUiDirectOpenDetail: null,
        formatTextLabel: null,
        styleTextLabel: {
          heading: '',
          font: [],
          alignment: '',
        },
        linkTextLabel: '',
        progressBarColor: '#000000',
        viewStyleAttachment: 'list',
        isPrivateFile: false,
        companyDrivePath: '',
        enableCopyValue: false,
      };

      this.$v.dataSetup.$reset();
    }

    if (this.isSearch) {
      this.list_field_key = this.fieldUiKey.filter(f => f.type === 'relation_record' && f.field_data_key).map(e => ({
        id: e.field_data_key,
        text: e.field_data_key,
        label: e.field_data_key,
        name: e.field_data_key,
      }));
    } else {
      this.list_field_key = this.fieldUiKey.filter(f => (f.type === 'relation_record' || f.type === 'relation_record_external_api') && f.field_ui_key).map((e) => {
        e.id = e.field_ui_key;
        e.text = e.name;
        e.label = e.name;
        return e;
      });
    }

    this.list_field_reference = this.fieldUiKey.filter(f => (f.type === 'relation_record' || f.type === 'relation_record_external_api') && f.field_ui_key).map((e) => {
      e.id = e.field_ui_key;
      e.text = e.name;
      e.label = e.name;
      return e;
    });

    if (this.fieldDetail.type === 'text' ||
    this.fieldDetail.type === 'descriptive' ||
    this.fieldDetail.type === 'number' ||
    this.fieldDetail.type === 'number_decimal' ||
    this.fieldDetail.type === 'date' ||
    this.fieldDetail.type === 'time' ||
    this.fieldDetail.type === 'date_time' ||
    this.fieldDetail.type === 'currency' ||
    this.fieldDetail.type === 'currency_selection' ||
    this.fieldDetail.type === 'single_selection' ||
    this.fieldDetail.type === 'relation_record' ||
    this.fieldDetail.type === 'relation_record_external_api' ||
    this.fieldDetail.type === 'progress_bar') this.getListFunction();
  },

  mounted() {
    this.setDataLocationType();
    this.setDataCamera();

    if (this.fieldDetail.type === 'relation_record' || this.fieldDetail.type === 'multiple_relation_record' || this.fieldDetail.type === 'dynamic_field') {
      this.dataSetup.filterOperator = this.fieldDetail.config ? this.fieldDetail.config.filter_operator : 'and';
    }

    setTimeout(() => {
      if (this.isBulk || this.isTableEditable) { this.dataSetup.grid = 12; }
      this.openEditor = true;
    }, 500);
    setTimeout(() => {
      this.isFirstLoad = false;
    }, 800);
  },

  methods: {
    ...mapActions('jStoreFormUi', ['actionSetForm', 'findFormUi']),
    ...mapActions('jStoreExperienceManagerV2', ['toggleModalExternalApi']),
    ...mapActions('jStoreForm', ['getListDataGroupByCompanyId', 'getListTableByGroupV2']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),
    ...mapMutations('jStoreExperienceManagerV2', [
      'setPropertiesOpened', 'setShowModalFieldLibrary',
      'setIsShowModalFieldFromGroup', 'setSourceModalFieldLibrary', 'setTargetStackedProperties',
      'setIsFieldGroup', 'setIsTableGroup', 'setIsDataPreview', 'setIsDataPreviewGroup',
    ]),
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),

    checkType() {
      let grid = null;

      if (this.dataSetup.type) {
        const typeNotGrid = ['location', 'attachment', 'multiple_attachment_dynamic', 'single_attachment', 'separator', 'custom_html', 'group', 'table_group', 'code_editor', 'digital_signature'];
        if (typeNotGrid.includes(this.dataSetup.type.id) || this.isBulk || this.isTableEditable) {
          grid = 12;
        } else {
          grid = 12;
        }
      } else {
        this.dataSetup.defaultValue = null;
      }

      return grid;
    },

    // Generate data if click button save
    generateData() {
      const { name, placeholder, type, variable, isMandatory, isDisable, isHidden, key, grid, width } = this.dataSetup;
      let dataConfig = null;
      if (this.dataSetup.type.id === 'location') {
        dataConfig = { map_type: this.dataSetup.locationType, is_show_maps: this.dataSetup.isShowMaps };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'single_selection' ||
            this.dataSetup.type.id === 'multiple_selection' ||
            this.dataSetup.type.id === 'photo') {
        dataConfig = { list_options: this.dataSetup.options };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'radio' || this.dataSetup.type.id === 'checkbox') {
        dataConfig = { list_options_object: this.dataSetup.optionsObject && this.dataSetup.optionsObject.length > 0 ? (this.dataSetup.optionsObject[0].value === null ? [{ label: null, value: null }] : this.dataSetup.optionsObject) : [{ label: null, value: null }] };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
        if (this.dataSetup.options && this.dataSetup.options.length > 0 && this.dataSetup.options[0] !== '') {
          dataConfig.list_options = this.dataSetup.options;
        }
      }
      if (this.dataSetup.type.id === 'attachment') {
        dataConfig = {
          list_options: this.dataSetup.options,
          accepted_file_type: this.dataSetup.acceptedFileType,
          is_use_camera: this.dataSetup.isUseCamera,
          is_can_access_gallery: this.dataSetup.sourceCamera,
          camera_type: this.dataSetup.chooseCamera,
          is_use_watermark: this.dataSetup.isUseWatermark,
          field_1: this.dataSetup.field1 ? this.dataSetup.field1 : null,
          field_2: this.dataSetup.field2 ? this.dataSetup.field2 : null,
          field_3: this.dataSetup.field3 ? this.dataSetup.field3 : null,
          view_style: this.dataSetup.viewStyleAttachment,
          private_file: this.dataSetup.isPrivateFile,
          companydrive_path: this.dataSetup.companyDrivePath,
        };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'single_attachment' || this.dataSetup.type.id === 'multiple_attachment_dynamic') {
        dataConfig = {
          list_options: [],
          accepted_file_type: this.dataSetup.acceptedFileType,
          is_use_camera: this.dataSetup.isUseCamera,
          is_can_access_gallery: this.dataSetup.sourceCamera,
          camera_type: this.dataSetup.chooseCamera,
          is_use_watermark: this.dataSetup.isUseWatermark,
          field_1: this.dataSetup.field1 ? this.dataSetup.field1 : null,
          field_2: this.dataSetup.field2 ? this.dataSetup.field2 : null,
          field_3: this.dataSetup.field3 ? this.dataSetup.field3 : null,
          view_style: this.dataSetup.viewStyleAttachment,
          private_file: this.dataSetup.isPrivateFile,
          companydrive_path: this.dataSetup.companyDrivePath,
        };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'relation_record' ||
            this.dataSetup.type.id === 'multiple_relation_record') {
        dataConfig = {
          data_source: {
            table_group: this.dataSetup.sourceData.tableGroup,
            form: this.dataSetup.sourceData.form,
            show_data_option: this.dataSetup.sourceData.showData,
            search_data_option: this.dataSetup.sourceData.searchData,
            set_value_selected: this.dataSetup.sourceData.setValue,
          },
          is_auto_show: this.dataSetup.isAutoShow,
          is_with_param: this.dataSetup.isWithParam,
          filter_column: this.dataSetup.filterColumn,
          field_key: this.dataSetup.fieldKey,
          filter: {},
          filter_operator: this.dataSetup.filterOperator ? this.dataSetup.filterOperator : 'and',
          sort: [],
        };
        if (this.dataSetup.sorting.key && this.dataSetup.sorting.order) {
          dataConfig.sort.push({
            [this.dataSetup.sorting.key.id]: this.dataSetup.sorting.order.id === 'asc' ? 1 : -1,
          });
        }
        if (this.dataSetup.filter.length > 0) {
          this.dataSetup.filter.forEach((e) => {
            if (e.key) {
              dataConfig.filter[e.key.id] = e.value;
            }
          });
        }
        if (this.dataSetup.type.id === 'relation_record' && !this.isTableEditable && !this.isBulk && !this.isSearch) {
          dataConfig.data_field_auto = this.dataSetup.fieldGroup;
          dataConfig.is_auto_fill = this.dataSetup.isAutoFill;
          dataConfig.direct_open_detail = {
            is_use_direct_open_detail: this.dataSetup.isDirectOpenDetail || false,
            form_ui_id: this.dataSetup.formUiDirectOpenDetail ? this.dataSetup.formUiDirectOpenDetail.id : '',
          };
          dataConfig.is_value_change = this.dataSetup.isValueChange;
          dataConfig.on_value_change = this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange;
        }

        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'relation_record_external_api' ||
            this.dataSetup.type.id === 'multiple_relation_record_external_api') {
        dataConfig = {
          data_source_external: this.dataSetup.sourceExternal,
          data_source_external_variable: this.dataSetup.sourceExternalVariable,
          data_source_external_set_value: this.dataSetup.sourceExternalSetValue,
          is_auto_show: this.dataSetup.isAutoShow,
        };
        if (this.dataSetup.type.id === 'relation_record_external_api') {
          dataConfig.data_field_auto = this.dataSetup.fieldGroup;
          dataConfig.is_auto_fill = this.dataSetup.isAutoFill;
          dataConfig.direct_open_detail = {
            is_use_direct_open_detail: this.dataSetup.isDirectOpenDetail || false,
            form_ui_id: this.dataSetup.formUiDirectOpenDetail ? this.dataSetup.formUiDirectOpenDetail.id : '',
          };
          dataConfig.is_value_change = this.dataSetup.isValueChange;
          dataConfig.on_value_change = this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange;
        }

        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'group' || this.dataSetup.type.id === 'table_group') {
        dataConfig = {
          data_field_group: this.dataSetup.fieldGroup,
          is_disable_add_more: this.dataSetup.isDisableAddMore,
          is_disable_delete_row: this.dataSetup.isDisableDeleteRow,
        };

        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'single_tags_selection' || this.dataSetup.type.id === 'multiple_tags_selection') {
        dataConfig = { list_tags: this.dataSetup.tags };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'custom_html') {
        dataConfig = { html: this.encodeHtmlEntities(this.dataSetup.html) };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if ((this.dataSetup.type.id === 'number' ||
            this.dataSetup.type.id === 'number_decimal' ||
            this.dataSetup.type.id === 'currency' ||
            this.dataSetup.type.id === 'currency_selection' ||
            this.dataSetup.type.id === 'text' ||
            this.dataSetup.type.id === 'date' ||
            this.dataSetup.type.id === 'time' ||
            this.dataSetup.type.id === 'date_time' ||
            this.dataSetup.type.id === 'toggle' ||
            this.dataSetup.type.id === 'password') && !this.isTableEditable && !this.isSearch && !this.isDataset) {
        dataConfig = {
          is_value_change: this.dataSetup.isValueChange,
          on_value_change: this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange,
          default_value: this.getDefaultValue(this.dataSetup.defaultValue, this.dataSetup.type.id),
        };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if ((this.dataSetup.type.id === 'single_selection' ||
            this.dataSetup.type.id === 'radio' ||
            this.dataSetup.type.id === 'checkbox' ||
            this.dataSetup.type.id === 'single_attachment') && !this.isTableEditable && !this.isBulk && !this.isSearch) {
        dataConfig.is_value_change = this.dataSetup.isValueChange;
        dataConfig.on_value_change = this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange;
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'code_editor') {
        dataConfig = { language: this.dataSetup.language };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if ((this.dataSetup.type.id === 'date' || this.dataSetup.type.id === 'date_time') && !this.isBulk && !this.isSearch && !this.isDataset) {
        if (dataConfig) dataConfig.is_disable_back_date = this.dataSetup.isDisableBackDate;
        else dataConfig = { is_disable_back_date: this.dataSetup.isDisableBackDate };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'descriptive' && !this.isDataset) {
        dataConfig = {
          is_value_change: this.dataSetup.isValueChange,
          on_value_change: this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange,
          default_value: this.dataSetup.defaultValue,
          enable_copy_value: this.dataSetup.enableCopyValue,
        };
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'single_selection') {
        dataConfig.default_value = this.dataSetup.defaultValue;
        if (this.isGroup && this.parentType === 'table_group') dataConfig.width = this.dataSetup.width;
      }
      if (this.dataSetup.type.id === 'multiple_relation_record' || this.dataSetup.type.id === 'multiple_relation_record_external_api') {
        dataConfig.allow_select_all_data = this.dataSetup.isAllowSelectAllData;
      }
      if (this.dataSetup.type.id === 'currency' && !this.isTableEditable) {
        dataConfig.allow_minus_value = this.dataSetup.isAllowMinusValue;
        dataConfig.default_currency = this.dataSetup.defaultCurrency || 'IDR';
        dataConfig.symbol_default_currency = this.dataSetup.defaultCurrency ? currency[this.dataSetup.defaultCurrency].symbol : 'Rp';
        dataConfig.name_default_currency = this.dataSetup.defaultCurrency ? currency[this.dataSetup.defaultCurrency].name : 'Indonesia Rupiah';
      }
      if (this.dataSetup.type.id === 'currency_selection') {
        dataConfig.allow_minus_value = this.dataSetup.isAllowMinusValue;
        dataConfig.default_currency = this.dataSetup.defaultCurrency;
        dataConfig.symbol_default_currency = this.dataSetup.defaultCurrency ? currency[this.dataSetup.defaultCurrency].symbol : '';
        dataConfig.name_default_currency = this.dataSetup.defaultCurrency ? currency[this.dataSetup.defaultCurrency].name : 'Indonesia Rupiah';
        dataConfig.load_rate = this.dataSetup.loadRate;
        dataConfig.editable_rate = this.dataSetup.isEditableRate;
        dataConfig.is_use_additional_data_key = this.dataSetup.isAdditionalDataKey;
        dataConfig.additional_data_key = this.dataSetup.isAdditionalDataKey ? {
          origin_amount: this.dataSetup.additionalOriginAmount ? this.dataSetup.additionalOriginAmount.id : null,
          origin_currency: this.dataSetup.additionalOriginCurrency ? this.dataSetup.additionalOriginCurrency.id : null,
          convertion_amount: this.dataSetup.additionalConvertionAmount ? this.dataSetup.additionalConvertionAmount.id : null,
          target_currency: this.dataSetup.additionalTargetCurrency ? this.dataSetup.additionalTargetCurrency.id : null,
          rate: this.dataSetup.additionalRate ? this.dataSetup.additionalRate.id : null,
        } : null;
      }
      if (this.dataSetup.type.id === 'dynamic_field' && this.dataSetup.viewOptions === 'render') {
        dataConfig = {
          view_options: this.dataSetup.viewOptions,
          field_reference: this.dataSetup.sourceData.fieldReference,
          data_source: {
            table_group: this.dataSetup.sourceData.tableGroup,
            form: this.dataSetup.sourceData.form,
            data_selection: this.dataSetup.sourceData.dataSelection,
          },
          filter: {},
          filter_operator: this.dataSetup.filterOperator ? this.dataSetup.filterOperator : 'and',
        };
        if (this.dataSetup.filter.length > 0) {
          this.dataSetup.filter.forEach((e) => {
            if (e.key) {
              dataConfig.filter[e.key.id] = e.value;
            }
          });
        }
      }
      if (this.dataSetup.type.id === 'dynamic_field' && this.dataSetup.viewOptions === 'settings') {
        dataConfig = {
          view_options: this.dataSetup.viewOptions,
        };
      }
      if (this.isDetailView && this.isApproverCanUpdate && this.type !== 'data_preview' && dataConfig) {
        dataConfig.allow_approver_update = this.dataSetup.isAllowApproverUpdate;
      }
      if (this.isDetailView && this.isApproverCanUpdate && this.type !== 'data_preview' && !dataConfig) {
        dataConfig = { allow_approver_update: this.dataSetup.isAllowApproverUpdate };
      }
      if ((
        this.dataSetup.type.id === 'date' ||
        this.dataSetup.type.id === 'date_time' ||
        this.dataSetup.type.id === 'time' ||
        this.dataSetup.type.id === 'timer'
      ) && !this.isSearch && !this.isDataset) {
        const timeZone = this.dataSetup.timezone || null;
        if (timeZone) {
          delete timeZone.id;
          delete timeZone.label;
        }
        if (dataConfig) dataConfig.timezone = timeZone;
        else dataConfig = { timezone: timeZone };
      }

      if (this.dataSetup.type.id === 'slider') {
        dataConfig = {
          is_value_change: this.dataSetup.isValueChange,
          on_value_change: this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : this.dataSetup.onValueChange,
          default_value: this.dataSetup.defaultValue,
          slider_type: this.dataSetup.sliderOptions,
        };
        if (this.dataSetup.sliderOptions === 'string') {
          dataConfig.list_options = this.dataSetup.options;
        } else {
          dataConfig.list_options = [Number(this.dataSetup.sliderMinimum), Number(this.dataSetup.sliderMaximum)];
        }
      }
      if (this.dataSetup.type.id === 'text_label') {
        dataConfig = {
          default_value: this.dataSetup.defaultValue,
          format_label: this.dataSetup.formatTextLabel,
          style_label: this.dataSetup.styleTextLabel,
          link_label: this.dataSetup.linkTextLabel,
        };
        if (this.dataSetup.formatTextLabel === 'currency') {
          dataConfig.default_currency = this.dataSetup.defaultCurrency || 'IDR';
          dataConfig.symbol_default_currency = this.dataSetup.defaultCurrency ? currency[this.dataSetup.defaultCurrency].symbol : 'Rp';
          dataConfig.name_default_currency = this.dataSetup.defaultCurrency ? currency[this.dataSetup.defaultCurrency].name : 'Indonesia Rupiah';
        }
        if (this.dataSetup.formatTextLabel === 'datetime' ||
                this.dataSetup.formatTextLabel === 'time' ||
                this.dataSetup.formatTextLabel === 'dd-mmm-yyyy' ||
                this.dataSetup.formatTextLabel === 'mmmm dd, yyyy') {
          const timeZone = this.dataSetup.timezone || null;
          if (timeZone) {
            delete timeZone.id;
            delete timeZone.label;
          }
          dataConfig.timezone = timeZone;
        }
      }
      if (this.dataSetup.type.id === 'progress_bar') {
        dataConfig = {
          color: this.dataSetup.progressBarColor,
          display_type: 'percentage',
        };
      }
      if (this.isShowInitialValue) dataConfig.init_value = this.dataSetup.initialValue.type ? this.getInitialValue() : null;

      const params = {
        name: name || this.fieldDetail.name,
        placeholder,
        type: type.id,
        field_data_key: variable && !this.isTableEditable ? (this.parentType.includes('external_api') ? variable : variable.id) : '',
        is_mandatory: isMandatory,
        is_hidden: isHidden,
        is_disable: isDisable,
        field_ui_key: key,
        grid_size: Number(grid),
        config: dataConfig,
      };
      if (this.isGroup && this.parentType === 'table_group') params.width = width;

      return params;
    },

    // Open modal field library (data preview, group, table group)
    openModalFieldLibrary(type) {
      if (!this.selectedIndexField || !this.selectedIndexSubField) {
        this.setShowModalFieldLibrary(true);
        this.setIsShowModalFieldFromGroup(true);
        if (this.stackLevel === 2) this.propertiesSubType = type;
        else this.propertiesType = type;

        this.changeDataModalField(true);
        this.setTargetStackedProperties(this.stackLevel);

        setTimeout(() => {
          const element = document.getElementById('modalFieldLibrary');
          if (element) element.classList.add('show');
        }, 100);
      }
    },

    // Edit field in stacked properties (data preview, group, table group)
    editField(index, type) {
      this.setTargetStackedProperties(this.stackLevel);

      if (this.stackLevel === 2) {
        this.selectedSubField = this.dataSetup.fieldGroup[index];
        this.selectedIndexSubField = index;
      } else {
        this.selectedField = this.dataSetup.fieldGroup[index];
        this.selectedIndexField = index;
      }

      if (this.stackLevel === 2) this.propertiesSubType = type;
      else this.propertiesType = type;

      this.changeDataModalField(true);
      if (this.stackLevel === 2) this.togglePropertiesSubField(true);
      else this.togglePropertiesField(true);
    },

    // Open/close stacked properties
    togglePropertiesField(status) {
      if (status) {
        setTimeout(() => {
          const elementParent = document.getElementById(this.id[0]);
          const element = document.getElementById(this.idPropertiesGroup);
          if (element) {
            elementParent.classList.add('show-properties-group');
            element.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const elementParent = document.getElementById(this.id[0]);
        const element = document.getElementById(this.idPropertiesGroup);
        if (element) {
          element.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-group');
        }

        setTimeout(() => {
          this.selectedField = null;
          this.selectedIndexField = null;
          this.propertiesType = null;
          this.isNewFieldGroup = false;
        }, 200);
      }
    },

    // Open/close stacked 3 properties
    togglePropertiesSubField(status) {
      if (status) {
        setTimeout(() => {
          const elementParent = document.getElementById(this.id[0]);
          const element2 = document.getElementById(this.idPropertiesSubGroup);
          if (element2) {
            elementParent.classList.add('show-properties-sub-group');
            element2.classList.add('show-properties-field');
          }
        }, 200);
      } else {
        const elementParent = document.getElementById(this.id[0]);
        const element2 = document.getElementById(this.idPropertiesSubGroup);
        if (element2) {
          element2.classList.remove('show-properties-field');
          elementParent.classList.remove('show-properties-sub-group');
        }

        setTimeout(() => {
          this.selectedSubField = null;
          this.selectedIndexSubField = null;
          this.propertiesSubType = null;
          this.isNewFieldGroup = false;
        }, 200);
      }
    },

    // Delete field in stacked properties (data preview, group, table group)
    deleteField(index) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete field ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          this.dataSetup.fieldGroup.splice(index || this.selectedIndexField || this.selectedIndexSubField, 1);
          if (this.selectedField && this.stackLevel !== 2) this.togglePropertiesField(false);
          if (this.selectedSubField && this.stackLevel === 2) this.togglePropertiesSubField(false);
        }
      });
    },

    // Preview Submit
    submitPreview() {
      if (!this.isGroup && !this.isFirstLoad) {
        const params = this.generateData();
        this.$emit('submit-preview', params);
      }
    },

    changeDataModalField(status) {
      const type = this.stackLevel === 2 ? this.propertiesSubType : this.propertiesType;
      if (type === 'group') {
        if (this.dataSetup.type.id === 'group') this.setIsFieldGroup(status);
        else if (this.dataSetup.type.id === 'table_group') this.setIsTableGroup(status);
      } else if (type === 'data_preview') {
        if (this.dataSetup.type.id === 'table_group') this.setIsDataPreviewGroup(status);
        else this.setIsDataPreview(status);
      }
    },

    // Submit data and send to parent component
    submitForm(isCancel) {
      const params = this.generateData();

      if (!isCancel) {
        this.$v.dataSetup.$touch();
        if (!this.$v.dataSetup.$error) {
          if (this.fieldDetail) {
            this.$emit('submit-mode', 'edit', params, isCancel);
          } else {
            this.$emit('submit-mode', 'add', params, isCancel);
          }
        } else {
          this.scrollToErrorField('error-input');
        }
      } else {
        if (this.fieldDetail) {
          this.$emit('submit-mode', 'edit', this.fieldDetail, isCancel);
        } else {
          this.$emit('submit-mode', 'add', this.fieldDetail, isCancel);
        }
        this.closeProperties();
      }
    },

    // Submit data in stacked properties
    submitField(mode, params, isCancel) {
      const key = this.stackLevel === 2 ? this.selectedSubField : this.selectedField;
      if (params.field_ui_key) {
        const findKeySame = this.dataSetup.fieldGroup.find(e => e.field_ui_key === params.field_ui_key);
        if (mode === 'add') {
          if (!findKeySame) {
            this.isError = false;
            if (!isCancel) {
              this.dataSetup.fieldGroup.push(params);
              if (this.stackLevel === 2) this.togglePropertiesSubField(false);
              else this.togglePropertiesField(false);
            }
          } else {
            this.isError = true;
            this.toggleProblem('Key cannot be the same!');
          }
        } else {
          // eslint-disable-next-line
          if (key.field_ui_key === params.field_ui_key) {
            this.isError = false;
            if (!isCancel) {
              if (this.stackLevel === 2) {
                this.dataSetup.fieldGroup[this.selectedIndexSubField] = params;
                this.togglePropertiesSubField(false);
              } else {
                this.dataSetup.fieldGroup[this.selectedIndexField] = params;
                this.togglePropertiesField(false);
              }
            }
          } else {
            // eslint-disable-next-line
            if (!findKeySame) {
              this.isError = false;
              if (!isCancel) {
                if (this.stackLevel === 2) {
                  this.dataSetup.fieldGroup[this.selectedIndexSubField] = params;
                  this.togglePropertiesSubField(false);
                } else {
                  this.dataSetup.fieldGroup[this.selectedIndexField] = params;
                  this.togglePropertiesField(false);
                }
              }
            } else {
              this.isError = true;
              this.toggleProblem('Key cannot be the same!');
            }
          }
        }
      } else if (!params.field_ui_key) {
        if (this.stackLevel === 2) this.dataSetup.fieldGroup.splice(this.selectedIndexSubField, 1);
        else this.dataSetup.fieldGroup.splice(this.selectedIndexField, 1);
      }
    },

    setDefaultValue(value, type) {
      return value || null;
    },

    getDefaultValue(value, type) {
      if (value) {
        if (type === 'number' || type === 'number_decimal' || type === 'currency') {
          return Number(value);
        } else if (type === 'date' || type === 'date_time' || type === 'time') {
          const convertDate = this.$moment(value).format('YYYY-MM-DD HH:mm');
          return new Date(Date.parse(convertDate)).getTime();
        } else {
          return value;
        }
      }
      return null;
    },

    setDataLocationType() {
      const value = this.dataSetup.locationType;

      if (value === 1) {
        this.currentLocation = true;
        this.manualLocation = false;
      } else if (value === 2) {
        this.currentLocation = false;
        this.manualLocation = true;
      } else if (value === 3) {
        this.currentLocation = true;
        this.manualLocation = true;
      }
    },

    setDataCamera() {
      const value = this.dataSetup.chooseCamera;

      if (value === 1) {
        this.rearCamera = true;
        this.frontCamera = true;
      } else if (value === 2) {
        this.rearCamera = false;
        this.frontCamera = true;
      } else if (value === 3) {
        this.rearCamera = true;
        this.frontCamera = false;
      }
    },

    converToLocalTime(data) {
      if (data) {
        const dt = new Date(data);
        const localDate = dt;

        const gmt = localDate;
        const min = gmt.getTime() / 1000 / 60; // convert gmt date to minutes
        const localNow = new Date().getTimezoneOffset(); // get the timezone
        const localTime = min + localNow; // get the local time

        const fullDate = new Date(localTime * 1000 * 60);
        const year = fullDate.getFullYear();
        const month = `0${fullDate.getMonth() + 1}`;
        const date = `0${fullDate.getDate()}`;
        const hours = `0${fullDate.getHours()}`;
        const minutes = `0${fullDate.getMinutes()}`;
        const utc = `${year}-${month.substr(-2)}-${date.substr(-2)}T${hours.substr(-2)}:${minutes.substr(-2)}:00.000Z`;

        return utc;
      }
      return null;
    },

    convertDateTime(data) {
      if (data) {
        // const date = new Date(data.toString().length === 13 || data.toString().length === 12 ? data : data * 1000);
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },

    convertTime(data) {
      if (data) {
        // const date = new Date(data.toString().length === 13 || data.toString().length === 12 ? data : data * 1000);
        const date = new Date(data);
        const hours = date.getHours();
        const minutes = date.getMinutes();
        return `${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
      }
      return null;
    },

    countSecond(str) {
      const date = new Date();
      return new Date(Date.parse(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()} ${str}:00`)).getTime();
    },

    addoptions() {
      this.dataSetup.options.push('');
    },

    deleteOptions(index) {
      this.dataSetup.options.splice(index, 1);
    },

    addoptionsObject() {
      this.dataSetup.optionsObject.push({ label: null, value: null });
    },

    deleteOptionsObject(index) {
      this.dataSetup.optionsObject.splice(index, 1);
    },

    addTags() {
      this.dataSetup.tags.push({
        name: '',
        background: '#000000',
        font_color: '#000000',
      });
    },

    deleteTags(index) {
      this.dataSetup.tags.splice(index, 1);
    },

    loadOptionsForm({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 50,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreAutomation/getListForm', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    openModalExternalUrl() {
      this.toggleModalExternalApi({ status: true, data: this.dataSetup.sourceExternal });
      this.setTargetStackedProperties(this.stackLevel);
    },

    submitExternalUrl(data) {
      this.dataSetup.sourceExternal = data;
      this.closeModalExternalUrl();
    },

    addFilter() {
      this.dataSetup.filter.push({
        key: null,
        value: null,
      });
    },

    deleteFilter(index) {
      this.dataSetup.filter.splice(index, 1);
    },

    closeFilterOptions(id) {
      this.dataSetup.filterOperator = id;
      this.showFilterOptions = false;
    },

    encodeHtmlEntities(str) {
      return he.encode(str);
    },

    deleteSourceField() {
      this.$emit('delete-field');
    },

    closeProperties() {
      this.$emit('close-properties');

      setTimeout(() => {
        this.dataSetup = {
          name: null,
          placeholder: null,
          variable: null,
          isMandatory: false,
          isDisable: this.isDataset,
          isHidden: false,
          key: null,
          locationType: 1,
          isShowMaps: false,
          options: [''],
          optionsObject: [
            { label: null, value: null },
          ],
          acceptedFileType: [],
          isUseCamera: false,
          isAutoFill: false,
          isWithParam: false,
          isAutoShow: false,
          sourceData: {
            tableGroup: null,
            form: null,
            showData: null,
            searchData: null,
            setValue: null,
            dataSelection: null,
            fieldReference: null,
          },
          filterColumn: null,
          fieldKey: null,
          sourceExternal: null,
          sourceExternalVariable: '',
          sourceExternalSetValue: null,
          fieldGroup: [],
          isDisableAddMore: false,
          isDisableDeleteRow: false,
          tags: [
            {
              name: '',
              background: '#000000',
              font_color: '#000000',
            },
          ],
          sourceCamera: null,
          chooseCamera: null,
          html: '',
          isUseWatermark: false,
          field1: null,
          field2: null,
          field3: null,
          isValueChange: false,
          onValueChange: '',
          grid: null,
          filter: [{ key: null, value: null }],
          filterOperator: null,
          sorting: { key: null, order: null },
          language: null,
          isDisableBackDate: false,
          defaultValue: null,
          width: null,
          isAllowSelectAllData: false,
          isAllowMinusValue: false,
          isAllowApproverUpdate: false,
          viewOptions: null,
          defaultCurrency: null,
          loadRate: null,
          isEditableRate: false,
          isAdditionalDataKey: false,
          additionalOriginAmount: null,
          additionalOriginCurrency: null,
          additionalConvertionAmount: null,
          additionalTargetCurrency: null,
          additionalRate: null,
          initialValue: {
            type: '',
            function_name: null,
            params: [],
            value: '',
          },
          sliderOptions: '',
          sliderMinimum: null,
          sliderMaximum: null,
          isDirectOpenDetail: false,
          formUiDirectOpenDetail: null,
          formatTextLabel: null,
          styleTextLabel: {
            heading: '',
            font: [],
            alignment: '',
          },
          linkTextLabel: '',
          progressBarColor: '#000000',
          viewStyleAttachment: 'list',
          isPrivateFile: false,
          companyDrivePath: '',
          enableCopyValue: false,
        };

        this.$v.dataSetup.$reset();
        this.isFirstLoad = true;
      }, 400);
    },

    setCurrencyOptions(isAllowMinusValue) {
      const options = Object.assign({}, this.exampleOptionCurrency);
      options.minimumValue = isAllowMinusValue ? '-9999999999999.99' : '0';
      const symbol = this.dataSetup.defaultCurrency ? currency[this.dataSetup.defaultCurrency].symbol : 'Rp';
      options.currencySymbol = symbol;
      return options;
    },

    changeCurrency() {
      this.showDefaultCurrency = false;
      setTimeout(() => { this.showDefaultCurrency = true; }, 10);
    },

    changeViewDynamic(id) {
      if ((!this.isDetailView && id === 'render') ||
        (this.isDetailView && this.isPageScreen) ||
      (this.isDetailView && !this.isPageScreen && id === 'render')) {
        this.dataSetup.viewOptions = id;
      }
    },

    getListGroupTable() {
      this.getListDataGroupByCompanyId().then((res) => {
        if (!res.error) {
          this.tableGroupOptions = res.data || [];

          if (this.fieldDetail.config && this.fieldDetail.config.data_source && !this.fieldDetail.config.data_source.table_group) {
            const formDataTableGroup = this.fieldDetail.config &&
            this.fieldDetail.config.data_source &&
            this.fieldDetail.config.data_source.form &&
            this.fieldDetail.config.data_source.form.tablegroup_id;
            const findTableGroup = res.data.find(f => f.id === formDataTableGroup);
            if (findTableGroup) {
              this.dataSetup.sourceData.tableGroup = findTableGroup;
            }
            const findTableGroupLegacy = res.data.find(f => f.id === 'legacy');
            if (findTableGroupLegacy && !formDataTableGroup) {
              this.dataSetup.sourceData.tableGroup = findTableGroupLegacy;
            }

            setTimeout(() => {
              this.dataSetup.sourceData.form = this.fieldDetail.type === 'relation_record' ||
                this.fieldDetail.type === 'multiple_relation_record' ? this.fieldDetail.config.data_source.form : null;
            }, 500);
          }

          setTimeout(() => { this.finishSetDataTableGroup = true; }, 1000);
        }
      });
    },

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    setValueDateAndAtime(val) {
      this.dataSetup.defaultValue = val;
    },

    fullscreenScript() {
      this.$emit('open-modal-full-script', this.$refs.scriptEditor !== undefined ? this.$refs.scriptEditor.getData() : '');
    },

    openModalFullScript(val) {
      this.$emit('open-modal-full-script', val);
    },

    openModalCompanyDrive() {
      this.$emit('open-modal-company-drive');
    },

    setInitialValueType(type) {
      if (!this.dataSetup.initialValue.type) {
        this.dataSetup.initialValue.type = type;
      } else if (this.dataSetup.initialValue.type !== type) {
        this.dataSetup.initialValue.type = type;
      } else if (this.dataSetup.initialValue.type === type) {
        this.dataSetup.initialValue.type = '';
      }
    },

    addParamInitialValue() {
      this.dataSetup.initialValue.params.push({
        variable: '',
        value: '',
      });
    },

    deleteParamInitialValue(index) {
      this.dataSetup.initialValue.params.splice(index, 1);
    },

    getInitialValue() {
      let params = {};
      if (this.dataSetup.initialValue.params && this.dataSetup.initialValue.params.length > 0) {
        params = this.dataSetup.initialValue.params.reduce((acc, cur) => ({ ...acc, [cur.variable]: cur.value }), {});
      }
      return {
        type: this.dataSetup.initialValue.type || '',
        function_name: this.dataSetup.initialValue.function_name || '',
        params,
        value: this.dataSetup.initialValue.value || '',
      };
    },

    setInitialValue(data) {
      const params = [];
      if (data.config && data.config.init_value && data.config.init_value.params) {
        const keys = Object.keys(data.config.init_value.params);
        const values = Object.values(data.config.init_value.params);

        if (keys.length > 0) {
          keys.forEach((key, index) => {
            params.push({
              variable: key,
              value: values[index],
            });
          });
        }
      }

      return {
        type: data.config && data.config.init_value && data.config.init_value.type ? data.config.init_value.type : '',
        function_name: data.config && data.config.init_value && data.config.init_value.function_name ? data.config.init_value.function_name : null,
        params,
        value: data.config && data.config.init_value && data.config.init_value.value ? data.config.init_value.value : '',
      };
    },

    loadOptionsFormUI({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 100,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreFormUi/actionGetFormUiListAsync', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    checkActiveStyleTextLabel(label, opt) {
      if (label === 'Font') {
        return this.dataSetup.styleTextLabel.font.find(f => f === opt);
      } else {
        return this.dataSetup.styleTextLabel[label.toLowerCase()] === opt;
      }
    },

    setStyleTextLabel(label, opt) {
      if (label === 'Font') {
        if (this.dataSetup.styleTextLabel.font.includes(opt)) {
          const index = this.dataSetup.styleTextLabel.font.findIndex(f => f === opt);
          this.dataSetup.styleTextLabel.font.splice(index, 1);
        } else {
          this.dataSetup.styleTextLabel.font.push(opt);
        }
      } else {
        this.dataSetup.styleTextLabel[label.toLowerCase()] = opt;
      }
    },

    setIconType(type) {
      const convertType = type.toLowerCase();
      let finalType = '';
      if (convertType === 'date' || convertType === 'mmmm dd, yyyy' || convertType === 'MMMM dd, yyyy' || convertType === 'dd-mmm-yyyy') {
        finalType = 'date';
      } else {
        finalType = convertType;
      }
      return finalType;
    },
  },

  validations() {
    return {
      dataSetup: {
        name: {
          required: requiredIf(() => !this.isTableEditable),
        },
        placeholder: {
          // required,
        },
        type: {
          required,
        },
        variable: {
          // required,
          required: requiredIf(() => this.dataSetup.type && !this.isTableEditable && (this.dataSetup.type.id !== 'separator' && this.dataSetup.type.id !== 'custom_html')),
        },
        isMandatory: {
          // required,
        },
        isDisable: {
          // required,
        },
        isHidden: { },
        key: {
          required: requiredIf(() => !this.isSearch),
        },
        locationType: {
          required: requiredIf(() => (this.dataSetup.type && this.dataSetup.type.id) === 'location'),
        },
        isShowMaps: { },
        options: {
          $each: {
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'single_selection' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_selection' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'attachment';
            }),
          },
        },
        optionsObject: {
          $each: {
            label: {
              required: requiredIf(() => {
                return (this.dataSetup.type && this.dataSetup.type.id) === 'radio' ||
                        (this.dataSetup.type && this.dataSetup.type.id) === 'checkbox';
              }),
            },
            value: {
              required: requiredIf(() => {
                return (this.dataSetup.type && this.dataSetup.type.id) === 'radio' ||
                        (this.dataSetup.type && this.dataSetup.type.id) === 'checkbox';
              }),
            },
          },
        },
        acceptedFileType: {
          required: requiredIf(() => {
            return (this.dataSetup.type && this.dataSetup.type.id) === 'attachment' ||
                    (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_attachment_dynamic' ||
                    (this.dataSetup.type && this.dataSetup.type.id) === 'single_attachment';
          }),
        },
        isUseCamera: {},
        isAutoFill: {},
        isWithParam: {},
        isAutoShow: {},
        sourceData: {
          tableGroup: {
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record' ||
                      ((this.dataSetup.type && this.dataSetup.type.id) === 'dynamic_field' &&
                      this.isDetailView && this.dataSetup.viewOptions === 'render');
            }),
          },
          form: {
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          showData: {
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          searchData: {
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          setValue: {
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record';
            }),
          },
          dataSelection: {
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'dynamic_field' &&
                      this.isDetailView && this.dataSetup.viewOptions === 'render';
            }),
          },
          fieldReference: {
            required: requiredIf(() => {
              return (this.dataSetup.type && this.dataSetup.type.id) === 'dynamic_field' &&
                      this.isDetailView && this.dataSetup.viewOptions === 'render';
            }),
          },
        },
        fieldGroup: {
          required: requiredIf(() => {
            return (this.dataSetup.type && this.dataSetup.type.id) === 'group' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'table_group';
          }),
        },
        filterColumn: {},
        fieldKey: {},
        isDisableAddMore: {},
        isDisableDeleteRow: {},
        sourceExternalVariable: {},
        sourceExternalSetValue: {},
        sourceCamera: {},
        chooseCamera: {},
        html: {},
        isUseWatermark: {},
        field1: {},
        field2: {},
        field3: {},
        isValueChange: {},
        onValueChange: {},
        grid: {},
        filter: {
          required: requiredIf(() => {
            return (this.dataSetup.type && this.dataSetup.type.id) === 'dynamic_field' && this.dataSetup.viewOptions === 'render';
          }),
          minLength: minLength(1),
          $each: {
            key: {
              required: requiredIf(() => {
                return (this.dataSetup.type && this.dataSetup.type.id) === 'dynamic_field' && this.dataSetup.viewOptions === 'render';
              }),
            },
            value: {
              required: requiredIf(() => {
                return (this.dataSetup.type && this.dataSetup.type.id) === 'dynamic_field' && this.dataSetup.viewOptions === 'render';
              }),
            },
          },
        },
        filterOperator: {},
        sorting: {
          key: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return ((this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record') &&
                      this.type !== 'data_preview';
            }),
          },
          order: {
            // eslint-disable-next-line arrow-body-style
            required: requiredIf(() => {
              return ((this.dataSetup.type && this.dataSetup.type.id) === 'relation_record' ||
                      (this.dataSetup.type && this.dataSetup.type.id) === 'multiple_relation_record') &&
                      this.type !== 'data_preview';
            }),
          },
        },
        language: {},
        isDisableBackDate: {},
        defaultValue: {},
        width: {},
        isAllowSelectAllData: {},
        isAllowMinusValue: {},
        viewOptions: {},
        defaultCurrency: {
          required: requiredIf(() => this.dataSetup.type && this.dataSetup.type.id === 'currency_selection'),
        },
        loadRate: {
          required: requiredIf(() => this.dataSetup.type && this.dataSetup.type.id === 'currency_selection'),
        },
        isEditableRate: {},
        isAdditionalDataKey: {},
        additionalOriginAmount: {
          required: requiredIf(() => this.dataSetup.isAdditionalDataKey),
        },
        additionalOriginCurrency: {
          required: requiredIf(() => this.dataSetup.isAdditionalDataKey),
        },
        additionalConvertionAmount: {
          required: requiredIf(() => this.dataSetup.isAdditionalDataKey),
        },
        additionalTargetCurrency: {
          required: requiredIf(() => this.dataSetup.isAdditionalDataKey),
        },
        additionalRate: {
          required: requiredIf(() => this.dataSetup.isAdditionalDataKey),
        },
        initialValue: {
          function_name: {
            required: requiredIf(() => this.dataSetup.initialValue.type === 'function'),
          },
          value: {
            required: requiredIf(() => this.dataSetup.initialValue.type === 'static_value'),
          },
        },
        isDirectOpenDetail: {},
        formUiDirectOpenDetail: {
          required: requiredIf(() => this.dataSetup.isDirectOpenDetail),
        },
        formatTextLabel: {
          required: requiredIf(() => this.dataSetup.type && this.dataSetup.type.id === 'text_label'),
        },
        isPrivateFile: {},
        companyDrivePath: {},
        enableCopyValue: {},
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/PropertiesField.vue